/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-9ecdf98c.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _circle, _path, _circle2, _path2, _circle3, _path3, _circle4, _path4, _circle5, _circle6, _path5, _circle7, _circle8, _path6, _circle9, _circle10, _path7, _circle11, _circle12, _path8, _circle13, _path9, _circle14, _path10, _circle15, _path11, _circle16, _path12, _circle17, _path13, _circle18, _path14, _circle19, _path15, _path16, _circle20, _path17, _circle21, _path18, _path19, _circle22, _path20, _circle23, _path21, _path22, _circle24, _path23, _circle25, _path24, _path25, _circle26, _path26, _circle27, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle28, _circle29, _path37, _path38, _circle30, _circle31, _path39, _path40, _circle32, _circle33, _path41, _path42, _circle34, _circle35, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _circle36, _path72, _path73, _circle37, _path74, _path75, _circle38, _path76, _path77, _circle39, _path78, _path79, _path80, _circle40, _circle41, _circle42, _circle43, _circle44, _path81, _path82, _circle45, _circle46, _circle47, _circle48, _circle49, _path83, _path84, _circle50, _circle51, _circle52, _circle53, _circle54, _path85, _path86, _circle55, _circle56, _circle57, _circle58, _circle59, _path87, _path88, _path89, _circle60, _circle61, _circle62, _circle63, _path90, _path91, _path92, _path93, _circle64, _circle65, _circle66, _circle67, _path94, _path95, _path96, _path97, _circle68, _circle69, _circle70, _circle71, _path98, _path99, _path100, _path101, _circle72, _circle73, _circle74, _circle75, _path102, _path103, _path104, _circle76, _path105, _path106, _circle77, _path107, _path108, _circle78, _path109, _path110, _circle79, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _circle80, _circle81, _path128, _path129, _path130, _circle82, _circle83, _path131, _path132, _path133, _circle84, _circle85, _path134, _path135, _path136, _circle86, _circle87, _path137, _path138, _path139, _path140, _circle88, _path141, _path142, _circle89, _path143, _path144, _circle90, _path145, _path146, _circle91, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _circle92, _circle93, _path162, _path163, _path164, _path165, _circle94, _circle95, _path166, _path167, _path168, _path169, _circle96, _circle97, _path170, _path171, _path172, _path173, _circle98, _circle99, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _circle100, _path182, _path183, _path184, _path185, _circle101, _path186, _path187, _path188, _path189, _circle102, _path190, _path191, _path192, _path193, _circle103, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _circle104, _path228, _circle105, _path229, _circle106, _path230, _circle107, _path231, _circle108, _path232, _circle109, _path233, _circle110, _path234, _circle111, _path235, _circle112, _path236, _circle113, _path237, _circle114, _path238, _circle115, _path239, _circle116, _path240, _circle117, _path241, _path242, _circle118, _path243, _circle119, _path244, _path245, _circle120, _path246, _circle121, _path247, _path248, _circle122, _path249, _circle123, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _circle124, _path268, _circle125, _path269, _circle126, _path270, _circle127, _path271, _circle128, _path272, _circle129, _path273, _circle130, _path274, _circle131, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _circle132, _circle133, _path385, _path386, _circle134, _circle135, _path387, _path388, _circle136, _circle137, _path389, _path390, _circle138, _circle139, _path391, _path392, _circle140, _path393, _path394, _circle141, _path395, _path396, _circle142, _path397, _path398, _circle143, _path399, _path400, _circle144, _circle145, _circle146, _path401, _path402, _circle147, _circle148, _circle149, _path403, _path404, _circle150, _circle151, _circle152, _path405, _path406, _circle153, _circle154, _circle155, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _circle156, _path540, _path541;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children"],
    _excluded49 = ["children"],
    _excluded50 = ["children"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"],
    _excluded99 = ["children"],
    _excluded100 = ["children"],
    _excluded101 = ["children"],
    _excluded102 = ["children"],
    _excluded103 = ["children"],
    _excluded104 = ["children"],
    _excluded105 = ["children"],
    _excluded106 = ["children"],
    _excluded107 = ["children"],
    _excluded108 = ["children"],
    _excluded109 = ["children"],
    _excluded110 = ["children"],
    _excluded111 = ["children"],
    _excluded112 = ["children"],
    _excluded113 = ["children"],
    _excluded114 = ["children"],
    _excluded115 = ["children"],
    _excluded116 = ["children"],
    _excluded117 = ["children"],
    _excluded118 = ["children"],
    _excluded119 = ["children"],
    _excluded120 = ["children"],
    _excluded121 = ["children"],
    _excluded122 = ["children"],
    _excluded123 = ["children"],
    _excluded124 = ["children"],
    _excluded125 = ["children"],
    _excluded126 = ["children"],
    _excluded127 = ["children"],
    _excluded128 = ["children"],
    _excluded129 = ["children"],
    _excluded130 = ["children"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["children"],
    _excluded134 = ["children"],
    _excluded135 = ["children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["children"],
    _excluded139 = ["children"],
    _excluded140 = ["children"],
    _excluded141 = ["children"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["children"],
    _excluded145 = ["children"],
    _excluded146 = ["children"],
    _excluded147 = ["children"],
    _excluded148 = ["children"],
    _excluded149 = ["children"],
    _excluded150 = ["children"],
    _excluded151 = ["children"],
    _excluded152 = ["children"],
    _excluded153 = ["children"],
    _excluded154 = ["children"],
    _excluded155 = ["children"],
    _excluded156 = ["children"],
    _excluded157 = ["children"],
    _excluded158 = ["children"],
    _excluded159 = ["children"],
    _excluded160 = ["children"],
    _excluded161 = ["children"],
    _excluded162 = ["children"],
    _excluded163 = ["children"],
    _excluded164 = ["children"],
    _excluded165 = ["children"],
    _excluded166 = ["children"],
    _excluded167 = ["children"],
    _excluded168 = ["children"],
    _excluded169 = ["children"],
    _excluded170 = ["children"],
    _excluded171 = ["children"],
    _excluded172 = ["children"],
    _excluded173 = ["children"],
    _excluded174 = ["children"],
    _excluded175 = ["children"],
    _excluded176 = ["children"],
    _excluded177 = ["children"],
    _excluded178 = ["children"],
    _excluded179 = ["children"],
    _excluded180 = ["children"],
    _excluded181 = ["children"],
    _excluded182 = ["children"],
    _excluded183 = ["children"],
    _excluded184 = ["children"],
    _excluded185 = ["children"],
    _excluded186 = ["children"],
    _excluded187 = ["children"],
    _excluded188 = ["children"],
    _excluded189 = ["children"],
    _excluded190 = ["children"],
    _excluded191 = ["children"],
    _excluded192 = ["children"],
    _excluded193 = ["children"],
    _excluded194 = ["children"],
    _excluded195 = ["children"],
    _excluded196 = ["children"],
    _excluded197 = ["children"],
    _excluded198 = ["children"],
    _excluded199 = ["children"],
    _excluded200 = ["children"],
    _excluded201 = ["children"],
    _excluded202 = ["children"],
    _excluded203 = ["children"],
    _excluded204 = ["children"],
    _excluded205 = ["children"],
    _excluded206 = ["children"],
    _excluded207 = ["children"],
    _excluded208 = ["children"],
    _excluded209 = ["children"],
    _excluded210 = ["children"],
    _excluded211 = ["children"],
    _excluded212 = ["children"],
    _excluded213 = ["children"],
    _excluded214 = ["children"],
    _excluded215 = ["children"],
    _excluded216 = ["children"],
    _excluded217 = ["children"],
    _excluded218 = ["children"],
    _excluded219 = ["children"],
    _excluded220 = ["children"],
    _excluded221 = ["children"],
    _excluded222 = ["children"],
    _excluded223 = ["children"],
    _excluded224 = ["children"],
    _excluded225 = ["children"],
    _excluded226 = ["children"],
    _excluded227 = ["children"],
    _excluded228 = ["children"],
    _excluded229 = ["children"],
    _excluded230 = ["children"],
    _excluded231 = ["children"],
    _excluded232 = ["children"],
    _excluded233 = ["children"],
    _excluded234 = ["children"],
    _excluded235 = ["children"],
    _excluded236 = ["children"],
    _excluded237 = ["children"],
    _excluded238 = ["children"],
    _excluded239 = ["children"],
    _excluded240 = ["children"],
    _excluded241 = ["children"],
    _excluded242 = ["children"],
    _excluded243 = ["children"],
    _excluded244 = ["children"],
    _excluded245 = ["children"],
    _excluded246 = ["children"],
    _excluded247 = ["children"],
    _excluded248 = ["children"],
    _excluded249 = ["children"],
    _excluded250 = ["children"];
var IbmEventAutomation16 = /*#__PURE__*/React.forwardRef(function IbmEventAutomation16(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "22",
    r: "2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.5,30c-3.0586,0-5.9485-1.4867-7.7305-3.9771l1.6265-1.1638c1.4075,1.9667,3.6892,3.1409,6.104,3.1409,3.969,0,7.2578-3.1002,7.4873-7.0579l1.9966.1157c-.2908,5.0143-4.4565,8.9421-9.4839,8.9421Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "23",
    r: "2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 19.0948l-1.9243-.5449c.188-.6638.2832-1.3535.2832-2.0499 0-4.1355-3.3645-7.5-7.5-7.5-1.0769 0-2.1157.223-3.0876.6628l-.8247-1.822c1.2329-.558 2.5491-.8408 3.9124-.8408 5.2383 0 9.5 4.2617 9.5 9.5 0 .8807-.1208 1.7537-.3589 2.5948zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.0254,19.8821c-3.0999-1.6578-5.0254-4.8696-5.0254-8.3821C3,6.4729,6.9277,2.307,11.9421,2.0161l.1157,1.9966c-3.9578.2297-7.0579,3.5186-7.0579,7.4873,0,2.7732,1.5208,5.3092,3.9688,6.6184l-.9434,1.7637Z"
  })), children);
});
var IbmEventEndpointMgmt32 = /*#__PURE__*/React.forwardRef(function IbmEventEndpointMgmt32(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "29",
    r: "2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30h-8c-1.1028 0-2-.8972-2-2v-4h2v4h8v2zM30 25h-2v-8h-5v-2h5c1.1028 0 2 .8972 2 2v8zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3zM9 17H4c-1.1028 0-2-.8972-2-2V7h2v8h5v2zM17 8h-2V4H7v-2h8c1.1028 0 2 .8972 2 2v4z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "2"
  })), children);
});
var IbmEventEndpointMgmt24 = /*#__PURE__*/React.forwardRef(function IbmEventEndpointMgmt24(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "29",
    r: "2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30h-8c-1.1028 0-2-.8972-2-2v-4h2v4h8v2zM30 25h-2v-8h-5v-2h5c1.1028 0 2 .8972 2 2v8zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3zM9 17H4c-1.1028 0-2-.8972-2-2V7h2v8h5v2zM17 8h-2V4H7v-2h8c1.1028 0 2 .8972 2 2v4z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "2"
  })), children);
});
var IbmEventEndpointMgmt20 = /*#__PURE__*/React.forwardRef(function IbmEventEndpointMgmt20(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "29",
    r: "2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30h-8c-1.1028 0-2-.8972-2-2v-4h2v4h8v2zM30 25h-2v-8h-5v-2h5c1.1028 0 2 .8972 2 2v8zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3zM9 17H4c-1.1028 0-2-.8972-2-2V7h2v8h5v2zM17 8h-2V4H7v-2h8c1.1028 0 2 .8972 2 2v4z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "2"
  })), children);
});
var IbmEventEndpointMgmt16 = /*#__PURE__*/React.forwardRef(function IbmEventEndpointMgmt16(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "29",
    r: "2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30h-8c-1.1028 0-2-.8972-2-2v-4h2v4h8v2zM30 25h-2v-8h-5v-2h5c1.1028 0 2 .8972 2 2v8zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3zM9 17H4c-1.1028 0-2-.8972-2-2V7h2v8h5v2zM17 8h-2V4H7v-2h8c1.1028 0 2 .8972 2 2v4z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "2"
  })), children);
});
var IbmEventProcessing32 = /*#__PURE__*/React.forwardRef(function IbmEventProcessing32(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30h-2.5v-2h2.5c3.0327 0 5.5-2.4673 5.5-5.5 0-2.5634-1.7395-4.7644-4.23-5.3528l.46-1.9465c3.3972.8026 5.77 3.8042 5.77 7.2993 0 4.1355-3.3645 7.5-7.5 7.5zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m7.77,16.7993c-3.3972-.8026-5.77-3.8042-5.77-7.2993C2,5.3645,5.3645,2,9.5,2h2.5v2h-2.5c-3.0327,0-5.5,2.4673-5.5,5.5,0,2.5634,1.7395,4.7645,4.23,5.3528l-.46,1.9465Z"
  })), children);
});
var IbmEventProcessing24 = /*#__PURE__*/React.forwardRef(function IbmEventProcessing24(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30h-2.5v-2h2.5c3.0327 0 5.5-2.4673 5.5-5.5 0-2.5634-1.7395-4.7644-4.23-5.3528l.46-1.9465c3.3972.8026 5.77 3.8042 5.77 7.2993 0 4.1355-3.3645 7.5-7.5 7.5zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m7.77,16.7993c-3.3972-.8026-5.77-3.8042-5.77-7.2993C2,5.3645,5.3645,2,9.5,2h2.5v2h-2.5c-3.0327,0-5.5,2.4673-5.5,5.5,0,2.5634,1.7395,4.7645,4.23,5.3528l-.46,1.9465Z"
  })), children);
});
var IbmEventProcessing20 = /*#__PURE__*/React.forwardRef(function IbmEventProcessing20(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30h-2.5v-2h2.5c3.0327 0 5.5-2.4673 5.5-5.5 0-2.5634-1.7395-4.7644-4.23-5.3528l.46-1.9465c3.3972.8026 5.77 3.8042 5.77 7.2993 0 4.1355-3.3645 7.5-7.5 7.5zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m7.77,16.7993c-3.3972-.8026-5.77-3.8042-5.77-7.2993C2,5.3645,5.3645,2,9.5,2h2.5v2h-2.5c-3.0327,0-5.5,2.4673-5.5,5.5,0,2.5634,1.7395,4.7645,4.23,5.3528l-.46,1.9465Z"
  })), children);
});
var IbmEventProcessing16 = /*#__PURE__*/React.forwardRef(function IbmEventProcessing16(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30h-2.5v-2h2.5c3.0327 0 5.5-2.4673 5.5-5.5 0-2.5634-1.7395-4.7644-4.23-5.3528l.46-1.9465c3.3972.8026 5.77 3.8042 5.77 7.2993 0 4.1355-3.3645 7.5-7.5 7.5zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m7.77,16.7993c-3.3972-.8026-5.77-3.8042-5.77-7.2993C2,5.3645,5.3645,2,9.5,2h2.5v2h-2.5c-3.0327,0-5.5,2.4673-5.5,5.5,0,2.5634,1.7395,4.7645,4.23,5.3528l-.46,1.9465Z"
  })), children);
});
var IbmEventStreams32 = /*#__PURE__*/React.forwardRef(function IbmEventStreams32(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m20,27c-2.9795,0-5.7693-1.1719-7.8555-3.2998l1.4282-1.4001c1.7068,1.7411,3.9895,2.7,6.4272,2.7,4.9626,0,9-4.0374,9-9,0-2.3705-.9138-4.6079-2.5732-6.3004l1.4282-1.4001c2.0281,2.0686,3.145,4.8033,3.145,7.7006,0,6.0654-4.9346,11-11,11Z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "27",
    r: "2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m4.2993,23.855c-2.1277-2.0861-3.2993-4.8757-3.2993-7.855C1,9.9346,5.9346,5,12,5c2.9795,0,5.7693,1.1719,7.8555,3.2998l-1.4282,1.4001c-1.7068-1.7411-3.9895-2.7-6.4272-2.7-4.9626,0-9,4.0374-9,9,0,2.4376.9587,4.7201,2.6997,6.427l-1.4004,1.428Z"
  })), children);
});
var IbmEventStreams24 = /*#__PURE__*/React.forwardRef(function IbmEventStreams24(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m20,27c-2.9795,0-5.7693-1.1719-7.8555-3.2998l1.4282-1.4001c1.7068,1.7411,3.9895,2.7,6.4272,2.7,4.9626,0,9-4.0374,9-9,0-2.3705-.9138-4.6079-2.5732-6.3004l1.4282-1.4001c2.0281,2.0686,3.145,4.8033,3.145,7.7006,0,6.0654-4.9346,11-11,11Z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "27",
    r: "2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m4.2993,23.855c-2.1277-2.0861-3.2993-4.8757-3.2993-7.855C1,9.9346,5.9346,5,12,5c2.9795,0,5.7693,1.1719,7.8555,3.2998l-1.4282,1.4001c-1.7068-1.7411-3.9895-2.7-6.4272-2.7-4.9626,0-9,4.0374-9,9,0,2.4376.9587,4.7201,2.6997,6.427l-1.4004,1.428Z"
  })), children);
});
var IbmEventStreams20 = /*#__PURE__*/React.forwardRef(function IbmEventStreams20(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m20,27c-2.9795,0-5.7693-1.1719-7.8555-3.2998l1.4282-1.4001c1.7068,1.7411,3.9895,2.7,6.4272,2.7,4.9626,0,9-4.0374,9-9,0-2.3705-.9138-4.6079-2.5732-6.3004l1.4282-1.4001c2.0281,2.0686,3.145,4.8033,3.145,7.7006,0,6.0654-4.9346,11-11,11Z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "27",
    r: "2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m4.2993,23.855c-2.1277-2.0861-3.2993-4.8757-3.2993-7.855C1,9.9346,5.9346,5,12,5c2.9795,0,5.7693,1.1719,7.8555,3.2998l-1.4282,1.4001c-1.7068-1.7411-3.9895-2.7-6.4272-2.7-4.9626,0-9,4.0374-9,9,0,2.4376.9587,4.7201,2.6997,6.427l-1.4004,1.428Z"
  })), children);
});
var IbmEventStreams16 = /*#__PURE__*/React.forwardRef(function IbmEventStreams16(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m20,27c-2.9795,0-5.7693-1.1719-7.8555-3.2998l1.4282-1.4001c1.7068,1.7411,3.9895,2.7,6.4272,2.7,4.9626,0,9-4.0374,9-9,0-2.3705-.9138-4.6079-2.5732-6.3004l1.4282-1.4001c2.0281,2.0686,3.145,4.8033,3.145,7.7006,0,6.0654-4.9346,11-11,11Z"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "27",
    r: "2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m4.2993,23.855c-2.1277-2.0861-3.2993-4.8757-3.2993-7.855C1,9.9346,5.9346,5,12,5c2.9795,0,5.7693,1.1719,7.8555,3.2998l-1.4282,1.4001c-1.7068-1.7411-3.9895-2.7-6.4272-2.7-4.9626,0-9,4.0374-9,9,0,2.4376.9587,4.7201,2.6997,6.427l-1.4004,1.428Z"
  })), children);
});
var IbmIbv32 = /*#__PURE__*/React.forwardRef(function IbmIbv32(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24c-3.8594 0-7-3.1401-7-7s3.1406-7 7-7 7 3.1401 7 7-3.1406 7-7 7zm0-12c-2.7568 0-5 2.2432-5 5s2.2432 5 5 5 5-2.2432 5-5-2.2432-5-5-5zM30 13h-2V4h-9v-2h9c1.1025 0 2 .897 2 2v9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30c-7.168,0-13-5.8315-13-13S7.832,4,15,4v2c-6.0654,0-11,4.9346-11,11s4.9346,11,11,11,11-4.9346,11-11v-1h2v1c0,7.1685-5.832,13-13,13Z"
  })), children);
});
var IbmIbv24 = /*#__PURE__*/React.forwardRef(function IbmIbv24(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24c-3.8594 0-7-3.1401-7-7s3.1406-7 7-7 7 3.1401 7 7-3.1406 7-7 7zm0-12c-2.7568 0-5 2.2432-5 5s2.2432 5 5 5 5-2.2432 5-5-2.2432-5-5-5zM30 13h-2V4h-9v-2h9c1.1025 0 2 .897 2 2v9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30c-7.168,0-13-5.8315-13-13S7.832,4,15,4v2c-6.0654,0-11,4.9346-11,11s4.9346,11,11,11,11-4.9346,11-11v-1h2v1c0,7.1685-5.832,13-13,13Z"
  })), children);
});
var IbmIbv20 = /*#__PURE__*/React.forwardRef(function IbmIbv20(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24c-3.8594 0-7-3.1401-7-7s3.1406-7 7-7 7 3.1401 7 7-3.1406 7-7 7zm0-12c-2.7568 0-5 2.2432-5 5s2.2432 5 5 5 5-2.2432 5-5-2.2432-5-5-5zM30 13h-2V4h-9v-2h9c1.1025 0 2 .897 2 2v9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30c-7.168,0-13-5.8315-13-13S7.832,4,15,4v2c-6.0654,0-11,4.9346-11,11s4.9346,11,11,11,11-4.9346,11-11v-1h2v1c0,7.1685-5.832,13-13,13Z"
  })), children);
});
var IbmIbv16 = /*#__PURE__*/React.forwardRef(function IbmIbv16(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24c-3.8594 0-7-3.1401-7-7s3.1406-7 7-7 7 3.1401 7 7-3.1406 7-7 7zm0-12c-2.7568 0-5 2.2432-5 5s2.2432 5 5 5 5-2.2432 5-5-2.2432-5-5-5zM30 13h-2V4h-9v-2h9c1.1025 0 2 .897 2 2v9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30c-7.168,0-13-5.8315-13-13S7.832,4,15,4v2c-6.0654,0-11,4.9346-11,11s4.9346,11,11,11,11-4.9346,11-11v-1h2v1c0,7.1685-5.832,13-13,13Z"
  })), children);
});
var IbmInstana32 = /*#__PURE__*/React.forwardRef(function IbmInstana32(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H11V19H9zM21 13H23V19H21zM13 11H15V24H13zM17 9H19V22H17z"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "5",
    r: "2"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "27",
    r: "2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0916 28h-8.0916v-2h8.0916l5.9082-10-2.6992-4.5679 1.7227-1.0176 2.6992 4.5679c.3701.6274.3701 1.4077 0 2.0352l-5.9092 10c-.3574.6055-1.0176.9824-1.7217.9824zM4.9768 21.5859l-2.6992-4.5684c-.3701-.6274-.3701-1.4077 0-2.0352l5.9092-10c.3584-.606 1.0176-.9824 1.7217-.9824h8.0916v2h-8.0916l-5.9082 10 2.6992 4.5684-1.7227 1.0176z"
  })), children);
});
var IbmInstana24 = /*#__PURE__*/React.forwardRef(function IbmInstana24(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H11V19H9zM21 13H23V19H21zM13 11H15V24H13zM17 9H19V22H17z"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "5",
    r: "2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "27",
    r: "2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0916 28h-8.0916v-2h8.0916l5.9082-10-2.6992-4.5679 1.7227-1.0176 2.6992 4.5679c.3701.6274.3701 1.4077 0 2.0352l-5.9092 10c-.3574.6055-1.0176.9824-1.7217.9824zM4.9768 21.5859l-2.6992-4.5684c-.3701-.6274-.3701-1.4077 0-2.0352l5.9092-10c.3584-.606 1.0176-.9824 1.7217-.9824h8.0916v2h-8.0916l-5.9082 10 2.6992 4.5684-1.7227 1.0176z"
  })), children);
});
var IbmInstana20 = /*#__PURE__*/React.forwardRef(function IbmInstana20(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H11V19H9zM21 13H23V19H21zM13 11H15V24H13zM17 9H19V22H17z"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "5",
    r: "2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "27",
    r: "2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0916 28h-8.0916v-2h8.0916l5.9082-10-2.6992-4.5679 1.7227-1.0176 2.6992 4.5679c.3701.6274.3701 1.4077 0 2.0352l-5.9092 10c-.3574.6055-1.0176.9824-1.7217.9824zM4.9768 21.5859l-2.6992-4.5684c-.3701-.6274-.3701-1.4077 0-2.0352l5.9092-10c.3584-.606 1.0176-.9824 1.7217-.9824h8.0916v2h-8.0916l-5.9082 10 2.6992 4.5684-1.7227 1.0176z"
  })), children);
});
var IbmInstana16 = /*#__PURE__*/React.forwardRef(function IbmInstana16(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H11V19H9zM21 13H23V19H21zM13 11H15V24H13zM17 9H19V22H17z"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "5",
    r: "2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "27",
    r: "2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0916 28h-8.0916v-2h8.0916l5.9082-10-2.6992-4.5679 1.7227-1.0176 2.6992 4.5679c.3701.6274.3701 1.4077 0 2.0352l-5.9092 10c-.3574.6055-1.0176.9824-1.7217.9824zM4.9768 21.5859l-2.6992-4.5684c-.3701-.6274-.3701-1.4077 0-2.0352l5.9092-10c.3584-.606 1.0176-.9824 1.7217-.9824h8.0916v2h-8.0916l-5.9082 10 2.6992 4.5684-1.7227 1.0176z"
  })), children);
});
var IbmMatch_36032 = /*#__PURE__*/React.forwardRef(function IbmMatch_36032(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
  })), children);
});
var IbmMatch_36024 = /*#__PURE__*/React.forwardRef(function IbmMatch_36024(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
  })), children);
});
var IbmMatch_36020 = /*#__PURE__*/React.forwardRef(function IbmMatch_36020(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
  })), children);
});
var IbmMatch_36016 = /*#__PURE__*/React.forwardRef(function IbmMatch_36016(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
  })), children);
});
var IbmMq32 = /*#__PURE__*/React.forwardRef(function IbmMq32(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
  })), children);
});
var IbmMq24 = /*#__PURE__*/React.forwardRef(function IbmMq24(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
  })), children);
});
var IbmMq20 = /*#__PURE__*/React.forwardRef(function IbmMq20(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
  })), children);
});
var IbmMq16 = /*#__PURE__*/React.forwardRef(function IbmMq16(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2\tc7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2\tc0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2\tc0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
  })), children);
});
var IbmOpenEnterpriseLanguages32 = /*#__PURE__*/React.forwardRef(function IbmOpenEnterpriseLanguages32(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
  })), children);
});
var IbmOpenEnterpriseLanguages24 = /*#__PURE__*/React.forwardRef(function IbmOpenEnterpriseLanguages24(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
  })), children);
});
var IbmOpenEnterpriseLanguages20 = /*#__PURE__*/React.forwardRef(function IbmOpenEnterpriseLanguages20(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
  })), children);
});
var IbmOpenEnterpriseLanguages16 = /*#__PURE__*/React.forwardRef(function IbmOpenEnterpriseLanguages16(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
  })), children);
});
var IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries32 = /*#__PURE__*/React.forwardRef(function IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries32(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM29 21h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m12,27.2998c-4.6531-1.6523-8-6.0869-8-11.2998,0-6.6167,5.3833-12,12-12,4.8311,0,8.9937,2.876,10.8945,7h2.1665c-2.0188-5.2544-7.1045-9-13.061-9-7.7197,0-14,6.2803-14,14,0,6.3291,4.2246,11.6846,10,13.4102v-2.1104Z"
  })), children);
});
var IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries24 = /*#__PURE__*/React.forwardRef(function IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries24(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM29 21h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m12,27.2998c-4.6531-1.6523-8-6.0869-8-11.2998,0-6.6167,5.3833-12,12-12,4.8311,0,8.9937,2.876,10.8945,7h2.1665c-2.0188-5.2544-7.1045-9-13.061-9-7.7197,0-14,6.2803-14,14,0,6.3291,4.2246,11.6846,10,13.4102v-2.1104Z"
  })), children);
});
var IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries20 = /*#__PURE__*/React.forwardRef(function IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries20(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM29 21h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m12,27.2998c-4.6531-1.6523-8-6.0869-8-11.2998,0-6.6167,5.3833-12,12-12,4.8311,0,8.9937,2.876,10.8945,7h2.1665c-2.0188-5.2544-7.1045-9-13.061-9-7.7197,0-14,6.2803-14,14,0,6.3291,4.2246,11.6846,10,13.4102v-2.1104Z"
  })), children);
});
var IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries16 = /*#__PURE__*/React.forwardRef(function IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries16(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM29 21h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m12,27.2998c-4.6531-1.6523-8-6.0869-8-11.2998,0-6.6167,5.3833-12,12-12,4.8311,0,8.9937,2.876,10.8945,7h2.1665c-2.0188-5.2544-7.1045-9-13.061-9-7.7197,0-14,6.2803-14,14,0,6.3291,4.2246,11.6846,10,13.4102v-2.1104Z"
  })), children);
});
var IbmPowerVs32 = /*#__PURE__*/React.forwardRef(function IbmPowerVs32(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "27",
    r: "1"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
  })), children);
});
var IbmPowerVs24 = /*#__PURE__*/React.forwardRef(function IbmPowerVs24(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "27",
    r: "1"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
  })), children);
});
var IbmPowerVs20 = /*#__PURE__*/React.forwardRef(function IbmPowerVs20(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "27",
    r: "1"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
  })), children);
});
var IbmPowerVs16 = /*#__PURE__*/React.forwardRef(function IbmPowerVs16(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "27",
    r: "1"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
  })), children);
});
var IbmPowerVsPrivateCloud32 = /*#__PURE__*/React.forwardRef(function IbmPowerVsPrivateCloud32(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m28,21.5859l-3.293-3.293c-.1953-.1953-.4512-.293-.707-.293s-.5117.0977-.707.293l-5,5c-.1875.1875-.293.4414-.293.707v6h2v-5.5859l4-4,4,4v5.5859h2v-10h-2v1.5859Z"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m9,16c0-3.8598,3.1402-7,7-7,1.7023,0,3.2635.6121,4.4783,1.6261l1.2822-1.5386c-1.561-1.3023-3.5685-2.0875-5.7604-2.0875-4.9706,0-9,4.0294-9,9,0,.5231.0541,1.0327.1398,1.5313l1.9693-.3404c-.0669-.3879-.1091-.7842-.1091-1.1909Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16c0-3.3084 1.3457-6.3084 3.5186-8.4813l-1.4182-1.4182c-2.5335 2.5335-4.1005 6.0334-4.1005 9.8994 0 7.732 6.268 14 14 14v-2c-6.6168 0-12-5.3832-12-12zM16 4c6.6168 0 12 5.3832 12 12h2c0-7.732-6.268-14-14-14-1.6813 0-3.2861.3116-4.7795.855l.6837 1.8803c1.2804-.4672 2.6558-.7353 4.0959-.7353z"
  })), children);
});
var IbmPowerVsPrivateCloud24 = /*#__PURE__*/React.forwardRef(function IbmPowerVsPrivateCloud24(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m28,21.5859l-3.293-3.293c-.1953-.1953-.4512-.293-.707-.293s-.5117.0977-.707.293l-5,5c-.1875.1875-.293.4414-.293.707v6h2v-5.5859l4-4,4,4v5.5859h2v-10h-2v1.5859Z"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m9,16c0-3.8598,3.1402-7,7-7,1.7023,0,3.2635.6121,4.4783,1.6261l1.2822-1.5386c-1.561-1.3023-3.5685-2.0875-5.7604-2.0875-4.9706,0-9,4.0294-9,9,0,.5231.0541,1.0327.1398,1.5313l1.9693-.3404c-.0669-.3879-.1091-.7842-.1091-1.1909Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16c0-3.3084 1.3457-6.3084 3.5186-8.4813l-1.4182-1.4182c-2.5335 2.5335-4.1005 6.0334-4.1005 9.8994 0 7.732 6.268 14 14 14v-2c-6.6168 0-12-5.3832-12-12zM16 4c6.6168 0 12 5.3832 12 12h2c0-7.732-6.268-14-14-14-1.6813 0-3.2861.3116-4.7795.855l.6837 1.8803c1.2804-.4672 2.6558-.7353 4.0959-.7353z"
  })), children);
});
var IbmPowerVsPrivateCloud20 = /*#__PURE__*/React.forwardRef(function IbmPowerVsPrivateCloud20(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m28,21.5859l-3.293-3.293c-.1953-.1953-.4512-.293-.707-.293s-.5117.0977-.707.293l-5,5c-.1875.1875-.293.4414-.293.707v6h2v-5.5859l4-4,4,4v5.5859h2v-10h-2v1.5859Z"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m9,16c0-3.8598,3.1402-7,7-7,1.7023,0,3.2635.6121,4.4783,1.6261l1.2822-1.5386c-1.561-1.3023-3.5685-2.0875-5.7604-2.0875-4.9706,0-9,4.0294-9,9,0,.5231.0541,1.0327.1398,1.5313l1.9693-.3404c-.0669-.3879-.1091-.7842-.1091-1.1909Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16c0-3.3084 1.3457-6.3084 3.5186-8.4813l-1.4182-1.4182c-2.5335 2.5335-4.1005 6.0334-4.1005 9.8994 0 7.732 6.268 14 14 14v-2c-6.6168 0-12-5.3832-12-12zM16 4c6.6168 0 12 5.3832 12 12h2c0-7.732-6.268-14-14-14-1.6813 0-3.2861.3116-4.7795.855l.6837 1.8803c1.2804-.4672 2.6558-.7353 4.0959-.7353z"
  })), children);
});
var IbmPowerVsPrivateCloud16 = /*#__PURE__*/React.forwardRef(function IbmPowerVsPrivateCloud16(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m28,21.5859l-3.293-3.293c-.1953-.1953-.4512-.293-.707-.293s-.5117.0977-.707.293l-5,5c-.1875.1875-.293.4414-.293.707v6h2v-5.5859l4-4,4,4v5.5859h2v-10h-2v1.5859Z"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m9,16c0-3.8598,3.1402-7,7-7,1.7023,0,3.2635.6121,4.4783,1.6261l1.2822-1.5386c-1.561-1.3023-3.5685-2.0875-5.7604-2.0875-4.9706,0-9,4.0294-9,9,0,.5231.0541,1.0327.1398,1.5313l1.9693-.3404c-.0669-.3879-.1091-.7842-.1091-1.1909Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16c0-3.3084 1.3457-6.3084 3.5186-8.4813l-1.4182-1.4182c-2.5335 2.5335-4.1005 6.0334-4.1005 9.8994 0 7.732 6.268 14 14 14v-2c-6.6168 0-12-5.3832-12-12zM16 4c6.6168 0 12 5.3832 12 12h2c0-7.732-6.268-14-14-14-1.6813 0-3.2861.3116-4.7795.855l.6837 1.8803c1.2804-.4672 2.6558-.7353 4.0959-.7353z"
  })), children);
});
var IbmPowerWithVpc32 = /*#__PURE__*/React.forwardRef(function IbmPowerWithVpc32(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zm-6-8v6h6v-6H3zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM28 7c0-.3701-.0669-.7212-.1611-1.0615l1.8574-1.0723-1-1.7324-1.8467 1.0664c-.5-.5088-1.1384-.873-1.8496-1.0581V1h-2v2.1421c-.7112.1851-1.3496.5493-1.8496 1.0581l-1.8467-1.0664-1 1.7324 1.8574 1.0723c-.0942.3403-.1611.6914-.1611 1.0615s.0669.7212.1611 1.0615l-1.8574 1.0723 1 1.7324 1.8467-1.0664c.5.5088 1.1394.8721 1.8496 1.0576v2.1426h2v-2.1426c.7102-.1855 1.3496-.5488 1.8496-1.0576l1.8467 1.0664 1-1.7324-1.8574-1.0723c.0942-.3403.1611-.6914.1611-1.0615zm-4 2c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmPowerWithVpc24 = /*#__PURE__*/React.forwardRef(function IbmPowerWithVpc24(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zm-6-8v6h6v-6H3zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM28 7c0-.3701-.0669-.7212-.1611-1.0615l1.8574-1.0723-1-1.7324-1.8467 1.0664c-.5-.5088-1.1384-.873-1.8496-1.0581V1h-2v2.1421c-.7112.1851-1.3496.5493-1.8496 1.0581l-1.8467-1.0664-1 1.7324 1.8574 1.0723c-.0942.3403-.1611.6914-.1611 1.0615s.0669.7212.1611 1.0615l-1.8574 1.0723 1 1.7324 1.8467-1.0664c.5.5088 1.1394.8721 1.8496 1.0576v2.1426h2v-2.1426c.7102-.1855 1.3496-.5488 1.8496-1.0576l1.8467 1.0664 1-1.7324-1.8574-1.0723c.0942-.3403.1611-.6914.1611-1.0615zm-4 2c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmPowerWithVpc20 = /*#__PURE__*/React.forwardRef(function IbmPowerWithVpc20(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zm-6-8v6h6v-6H3zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM28 7c0-.3701-.0669-.7212-.1611-1.0615l1.8574-1.0723-1-1.7324-1.8467 1.0664c-.5-.5088-1.1384-.873-1.8496-1.0581V1h-2v2.1421c-.7112.1851-1.3496.5493-1.8496 1.0581l-1.8467-1.0664-1 1.7324 1.8574 1.0723c-.0942.3403-.1611.6914-.1611 1.0615s.0669.7212.1611 1.0615l-1.8574 1.0723 1 1.7324 1.8467-1.0664c.5.5088 1.1394.8721 1.8496 1.0576v2.1426h2v-2.1426c.7102-.1855 1.3496-.5488 1.8496-1.0576l1.8467 1.0664 1-1.7324-1.8574-1.0723c.0942-.3403.1611-.6914.1611-1.0615zm-4 2c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmPowerWithVpc16 = /*#__PURE__*/React.forwardRef(function IbmPowerWithVpc16(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zm-6-8v6h6v-6H3zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM28 7c0-.3701-.0669-.7212-.1611-1.0615l1.8574-1.0723-1-1.7324-1.8467 1.0664c-.5-.5088-1.1384-.873-1.8496-1.0581V1h-2v2.1421c-.7112.1851-1.3496.5493-1.8496 1.0581l-1.8467-1.0664-1 1.7324 1.8574 1.0723c-.0942.3403-.1611.6914-.1611 1.0615s.0669.7212.1611 1.0615l-1.8574 1.0723 1 1.7324 1.8467-1.0664c.5.5088 1.1394.8721 1.8496 1.0576v2.1426h2v-2.1426c.7102-.1855 1.3496-.5488 1.8496-1.0576l1.8467 1.0664 1-1.7324-1.8574-1.0723c.0942-.3403.1611-.6914.1611-1.0615zm-4 2c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmPrivatePathServices32 = /*#__PURE__*/React.forwardRef(function IbmPrivatePathServices32(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m24,16c-1.3019,0-2.4016.8385-2.8157,2h-9.1843v-2h-6v6h6v-2h9.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3Zm-14,4h-2v-2h2v2Zm14,0c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8321,11.22c-.8432-4.6665-4.9267-8.22-9.8321-8.22S7.0109,6.5535,6.1678,11.22c-3.5296.8317-6.1678,4.0001-6.1678,7.78,0,4.4111,3.5889,8,8,8h4v-2h-4c-3.3086,0-6-2.6914-6-6s2.6914-6,6-6c0-4.4111,3.5889-8,8-8s8,3.5889,8,8c3.3086,0,6,2.6914,6,6s-2.6914,6-6,6h-8v2h8c4.4111,0,8-3.5889,8-8,0-3.7799-2.6382-6.9484-6.1679-7.78Z"
  })), children);
});
var IbmPrivatePathServices24 = /*#__PURE__*/React.forwardRef(function IbmPrivatePathServices24(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m24,16c-1.3019,0-2.4016.8385-2.8157,2h-9.1843v-2h-6v6h6v-2h9.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3Zm-14,4h-2v-2h2v2Zm14,0c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8321,11.22c-.8432-4.6665-4.9267-8.22-9.8321-8.22S7.0109,6.5535,6.1678,11.22c-3.5296.8317-6.1678,4.0001-6.1678,7.78,0,4.4111,3.5889,8,8,8h4v-2h-4c-3.3086,0-6-2.6914-6-6s2.6914-6,6-6c0-4.4111,3.5889-8,8-8s8,3.5889,8,8c3.3086,0,6,2.6914,6,6s-2.6914,6-6,6h-8v2h8c4.4111,0,8-3.5889,8-8,0-3.7799-2.6382-6.9484-6.1679-7.78Z"
  })), children);
});
var IbmPrivatePathServices20 = /*#__PURE__*/React.forwardRef(function IbmPrivatePathServices20(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m24,16c-1.3019,0-2.4016.8385-2.8157,2h-9.1843v-2h-6v6h6v-2h9.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3Zm-14,4h-2v-2h2v2Zm14,0c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8321,11.22c-.8432-4.6665-4.9267-8.22-9.8321-8.22S7.0109,6.5535,6.1678,11.22c-3.5296.8317-6.1678,4.0001-6.1678,7.78,0,4.4111,3.5889,8,8,8h4v-2h-4c-3.3086,0-6-2.6914-6-6s2.6914-6,6-6c0-4.4111,3.5889-8,8-8s8,3.5889,8,8c3.3086,0,6,2.6914,6,6s-2.6914,6-6,6h-8v2h8c4.4111,0,8-3.5889,8-8,0-3.7799-2.6382-6.9484-6.1679-7.78Z"
  })), children);
});
var IbmPrivatePathServices16 = /*#__PURE__*/React.forwardRef(function IbmPrivatePathServices16(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m24,16c-1.3019,0-2.4016.8385-2.8157,2h-9.1843v-2h-6v6h6v-2h9.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3Zm-14,4h-2v-2h2v2Zm14,0c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8321,11.22c-.8432-4.6665-4.9267-8.22-9.8321-8.22S7.0109,6.5535,6.1678,11.22c-3.5296.8317-6.1678,4.0001-6.1678,7.78,0,4.4111,3.5889,8,8,8h4v-2h-4c-3.3086,0-6-2.6914-6-6s2.6914-6,6-6c0-4.4111,3.5889-8,8-8s8,3.5889,8,8c3.3086,0,6,2.6914,6,6s-2.6914,6-6,6h-8v2h8c4.4111,0,8-3.5889,8-8,0-3.7799-2.6382-6.9484-6.1679-7.78Z"
  })), children);
});
var IbmProcessMining32 = /*#__PURE__*/React.forwardRef(function IbmProcessMining32(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22c-1.8584,0-3.4106,1.2798-3.8579,3h-12.2842c-.3635-1.3984-1.4629-2.4927-2.8579-2.8579v-3.1421c0-1.1025.8972-2,2-2h14c2.2056,0,4-1.7944,4-4v-3.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v3.1421c0,1.1025-.8972,2-2,2h-14c-2.2056,0-4,1.7944-4,4v3.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4,1.8584,0,3.4106-1.2798,3.8579-3h12.2842c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-2-16c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2ZM6,28c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Zm20,0c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m6,10c.7395,0,1.4241-.2153,2.019-.5669l3.5669,3.5669,1.4141-1.4141-3.5669-3.5669c.3516-.5947.5669-1.2798.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4Zm0-6c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Z"
  })), children);
});
var IbmProcessMining24 = /*#__PURE__*/React.forwardRef(function IbmProcessMining24(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22c-1.8584,0-3.4106,1.2798-3.8579,3h-12.2842c-.3635-1.3984-1.4629-2.4927-2.8579-2.8579v-3.1421c0-1.1025.8972-2,2-2h14c2.2056,0,4-1.7944,4-4v-3.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v3.1421c0,1.1025-.8972,2-2,2h-14c-2.2056,0-4,1.7944-4,4v3.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4,1.8584,0,3.4106-1.2798,3.8579-3h12.2842c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-2-16c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2ZM6,28c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Zm20,0c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m6,10c.7395,0,1.4241-.2153,2.019-.5669l3.5669,3.5669,1.4141-1.4141-3.5669-3.5669c.3516-.5947.5669-1.2798.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4Zm0-6c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Z"
  })), children);
});
var IbmProcessMining20 = /*#__PURE__*/React.forwardRef(function IbmProcessMining20(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22c-1.8584,0-3.4106,1.2798-3.8579,3h-12.2842c-.3635-1.3984-1.4629-2.4927-2.8579-2.8579v-3.1421c0-1.1025.8972-2,2-2h14c2.2056,0,4-1.7944,4-4v-3.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v3.1421c0,1.1025-.8972,2-2,2h-14c-2.2056,0-4,1.7944-4,4v3.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4,1.8584,0,3.4106-1.2798,3.8579-3h12.2842c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-2-16c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2ZM6,28c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Zm20,0c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m6,10c.7395,0,1.4241-.2153,2.019-.5669l3.5669,3.5669,1.4141-1.4141-3.5669-3.5669c.3516-.5947.5669-1.2798.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4Zm0-6c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Z"
  })), children);
});
var IbmProcessMining16 = /*#__PURE__*/React.forwardRef(function IbmProcessMining16(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22c-1.8584,0-3.4106,1.2798-3.8579,3h-12.2842c-.3635-1.3984-1.4629-2.4927-2.8579-2.8579v-3.1421c0-1.1025.8972-2,2-2h14c2.2056,0,4-1.7944,4-4v-3.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v3.1421c0,1.1025-.8972,2-2,2h-14c-2.2056,0-4,1.7944-4,4v3.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4,1.8584,0,3.4106-1.2798,3.8579-3h12.2842c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-2-16c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2ZM6,28c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Zm20,0c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m6,10c.7395,0,1.4241-.2153,2.019-.5669l3.5669,3.5669,1.4141-1.4141-3.5669-3.5669c.3516-.5947.5669-1.2798.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4Zm0-6c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Z"
  })), children);
});
var IbmSaasConsole32 = /*#__PURE__*/React.forwardRef(function IbmSaasConsole32(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "20",
    r: "1"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m24,26c-2.2165,0-4.1514-1.2112-5.1903-3.0034l-1.7326,1.0002c1.3834,2.3906,3.9622,4.0032,6.9229,4.0032s5.5395-1.6125,6.9229-4.0032l-1.7326-1.0002c-1.0389,1.7922-2.9738,3.0034-5.1903,3.0034Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m24,14c2.1357,0,4.127,1.1494,5.1973,3l1.7314-1.001c-1.4263-2.4668-4.0815-3.999-6.9287-3.999s-5.5024,1.5322-6.938,4.0151l-3.8647,6.9849c-1.0703,1.8506-3.0615,3-5.1973,3s-4.127-1.1494-5.1973-3l-1.7314,1.001c1.4263,2.4668,4.0815,3.999,6.9287,3.999s5.5024-1.5322,6.938-4.0151l3.8647-6.9849c1.0703-1.8506,3.0615-3,5.1973-3Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c2.2165 0 4.1514 1.2112 5.1903 3.0034l1.7326-1.0002c-1.3834-2.3906-3.9622-4.0032-6.9229-4.0032s-5.5395 1.6125-6.9229 4.0032l1.7326 1.0002c1.0389-1.7922 2.9738-3.0034 5.1903-3.0034zM16 6c2.7571 0 5.2571 1.1216 7.0678 2.9321l1.4135-1.4133c-2.1729-2.1731-5.1729-3.5188-8.4813-3.5188s-6.3083 1.3457-8.4813 3.5188l1.4135 1.4133c1.8107-1.8105 4.3107-2.9321 7.0678-2.9321z"
  })), children);
});
var IbmSaasConsole24 = /*#__PURE__*/React.forwardRef(function IbmSaasConsole24(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "20",
    r: "1"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m24,26c-2.2165,0-4.1514-1.2112-5.1903-3.0034l-1.7326,1.0002c1.3834,2.3906,3.9622,4.0032,6.9229,4.0032s5.5395-1.6125,6.9229-4.0032l-1.7326-1.0002c-1.0389,1.7922-2.9738,3.0034-5.1903,3.0034Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m24,14c2.1357,0,4.127,1.1494,5.1973,3l1.7314-1.001c-1.4263-2.4668-4.0815-3.999-6.9287-3.999s-5.5024,1.5322-6.938,4.0151l-3.8647,6.9849c-1.0703,1.8506-3.0615,3-5.1973,3s-4.127-1.1494-5.1973-3l-1.7314,1.001c1.4263,2.4668,4.0815,3.999,6.9287,3.999s5.5024-1.5322,6.938-4.0151l3.8647-6.9849c1.0703-1.8506,3.0615-3,5.1973-3Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c2.2165 0 4.1514 1.2112 5.1903 3.0034l1.7326-1.0002c-1.3834-2.3906-3.9622-4.0032-6.9229-4.0032s-5.5395 1.6125-6.9229 4.0032l1.7326 1.0002c1.0389-1.7922 2.9738-3.0034 5.1903-3.0034zM16 6c2.7571 0 5.2571 1.1216 7.0678 2.9321l1.4135-1.4133c-2.1729-2.1731-5.1729-3.5188-8.4813-3.5188s-6.3083 1.3457-8.4813 3.5188l1.4135 1.4133c1.8107-1.8105 4.3107-2.9321 7.0678-2.9321z"
  })), children);
});
var IbmSaasConsole20 = /*#__PURE__*/React.forwardRef(function IbmSaasConsole20(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "20",
    r: "1"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m24,26c-2.2165,0-4.1514-1.2112-5.1903-3.0034l-1.7326,1.0002c1.3834,2.3906,3.9622,4.0032,6.9229,4.0032s5.5395-1.6125,6.9229-4.0032l-1.7326-1.0002c-1.0389,1.7922-2.9738,3.0034-5.1903,3.0034Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m24,14c2.1357,0,4.127,1.1494,5.1973,3l1.7314-1.001c-1.4263-2.4668-4.0815-3.999-6.9287-3.999s-5.5024,1.5322-6.938,4.0151l-3.8647,6.9849c-1.0703,1.8506-3.0615,3-5.1973,3s-4.127-1.1494-5.1973-3l-1.7314,1.001c1.4263,2.4668,4.0815,3.999,6.9287,3.999s5.5024-1.5322,6.938-4.0151l3.8647-6.9849c1.0703-1.8506,3.0615-3,5.1973-3Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c2.2165 0 4.1514 1.2112 5.1903 3.0034l1.7326-1.0002c-1.3834-2.3906-3.9622-4.0032-6.9229-4.0032s-5.5395 1.6125-6.9229 4.0032l1.7326 1.0002c1.0389-1.7922 2.9738-3.0034 5.1903-3.0034zM16 6c2.7571 0 5.2571 1.1216 7.0678 2.9321l1.4135-1.4133c-2.1729-2.1731-5.1729-3.5188-8.4813-3.5188s-6.3083 1.3457-8.4813 3.5188l1.4135 1.4133c1.8107-1.8105 4.3107-2.9321 7.0678-2.9321z"
  })), children);
});
var IbmSaasConsole16 = /*#__PURE__*/React.forwardRef(function IbmSaasConsole16(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "20",
    r: "1"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m24,26c-2.2165,0-4.1514-1.2112-5.1903-3.0034l-1.7326,1.0002c1.3834,2.3906,3.9622,4.0032,6.9229,4.0032s5.5395-1.6125,6.9229-4.0032l-1.7326-1.0002c-1.0389,1.7922-2.9738,3.0034-5.1903,3.0034Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m24,14c2.1357,0,4.127,1.1494,5.1973,3l1.7314-1.001c-1.4263-2.4668-4.0815-3.999-6.9287-3.999s-5.5024,1.5322-6.938,4.0151l-3.8647,6.9849c-1.0703,1.8506-3.0615,3-5.1973,3s-4.127-1.1494-5.1973-3l-1.7314,1.001c1.4263,2.4668,4.0815,3.999,6.9287,3.999s5.5024-1.5322,6.938-4.0151l3.8647-6.9849c1.0703-1.8506,3.0615-3,5.1973-3Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c2.2165 0 4.1514 1.2112 5.1903 3.0034l1.7326-1.0002c-1.3834-2.3906-3.9622-4.0032-6.9229-4.0032s-5.5395 1.6125-6.9229 4.0032l1.7326 1.0002c1.0389-1.7922 2.9738-3.0034 5.1903-3.0034zM16 6c2.7571 0 5.2571 1.1216 7.0678 2.9321l1.4135-1.4133c-2.1729-2.1731-5.1729-3.5188-8.4813-3.5188s-6.3083 1.3457-8.4813 3.5188l1.4135 1.4133c1.8107-1.8105 4.3107-2.9321 7.0678-2.9321z"
  })), children);
});
var IbmSapOnPower32 = /*#__PURE__*/React.forwardRef(function IbmSapOnPower32(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4s-13 0-13 0zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM25.5 12h-6.5c-.5522 0-1-.4478-1-1V4c0-.5522.4478-1 1-1h12c.3828 0 .7319.2185.8994.5629.0675.1389.1006.2884.1006.4371 0 .22-.0725.4382-.2136.6178l-5.5 7c-.1897.2413-.4795.3822-.7864.3822zm-5.5-2h5.0139l3.9287-5h-8.9426v5zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmSapOnPower24 = /*#__PURE__*/React.forwardRef(function IbmSapOnPower24(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4s-13 0-13 0zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM25.5 12h-6.5c-.5522 0-1-.4478-1-1V4c0-.5522.4478-1 1-1h12c.3828 0 .7319.2185.8994.5629.0675.1389.1006.2884.1006.4371 0 .22-.0725.4382-.2136.6178l-5.5 7c-.1897.2413-.4795.3822-.7864.3822zm-5.5-2h5.0139l3.9287-5h-8.9426v5zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmSapOnPower20 = /*#__PURE__*/React.forwardRef(function IbmSapOnPower20(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4s-13 0-13 0zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM25.5 12h-6.5c-.5522 0-1-.4478-1-1V4c0-.5522.4478-1 1-1h12c.3828 0 .7319.2185.8994.5629.0675.1389.1006.2884.1006.4371 0 .22-.0725.4382-.2136.6178l-5.5 7c-.1897.2413-.4795.3822-.7864.3822zm-5.5-2h5.0139l3.9287-5h-8.9426v5zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmSapOnPower16 = /*#__PURE__*/React.forwardRef(function IbmSapOnPower16(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4s-13 0-13 0zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM25.5 12h-6.5c-.5522 0-1-.4478-1-1V4c0-.5522.4478-1 1-1h12c.3828 0 .7319.2185.8994.5629.0675.1389.1006.2884.1006.4371 0 .22-.0725.4382-.2136.6178l-5.5 7c-.1897.2413-.4795.3822-.7864.3822zm-5.5-2h5.0139l3.9287-5h-8.9426v5zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
var IbmSecureInfrastructureOnVpcForRegulatedIndustries32 = /*#__PURE__*/React.forwardRef(function IbmSecureInfrastructureOnVpcForRegulatedIndustries32(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM23 30l-2.1-1c-1.7-.8-2.9-2.6-2.9-4.5v-6.5h10v6.5c0 1.9-1.1 3.7-2.9 4.5l-2.1 1zm-3-10v4.5c0 1.2.7 2.2 1.7 2.7l1.3.6 1.3-.6c1-.5 1.7-1.6 1.7-2.7v-4.5h-6zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmSecureInfrastructureOnVpcForRegulatedIndustries24 = /*#__PURE__*/React.forwardRef(function IbmSecureInfrastructureOnVpcForRegulatedIndustries24(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM23 30l-2.1-1c-1.7-.8-2.9-2.6-2.9-4.5v-6.5h10v6.5c0 1.9-1.1 3.7-2.9 4.5l-2.1 1zm-3-10v4.5c0 1.2.7 2.2 1.7 2.7l1.3.6 1.3-.6c1-.5 1.7-1.6 1.7-2.7v-4.5h-6zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmSecureInfrastructureOnVpcForRegulatedIndustries20 = /*#__PURE__*/React.forwardRef(function IbmSecureInfrastructureOnVpcForRegulatedIndustries20(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM23 30l-2.1-1c-1.7-.8-2.9-2.6-2.9-4.5v-6.5h10v6.5c0 1.9-1.1 3.7-2.9 4.5l-2.1 1zm-3-10v4.5c0 1.2.7 2.2 1.7 2.7l1.3.6 1.3-.6c1-.5 1.7-1.6 1.7-2.7v-4.5h-6zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmSecureInfrastructureOnVpcForRegulatedIndustries16 = /*#__PURE__*/React.forwardRef(function IbmSecureInfrastructureOnVpcForRegulatedIndustries16(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM23 30l-2.1-1c-1.7-.8-2.9-2.6-2.9-4.5v-6.5h10v6.5c0 1.9-1.1 3.7-2.9 4.5l-2.1 1zm-3-10v4.5c0 1.2.7 2.2 1.7 2.7l1.3.6 1.3-.6c1-.5 1.7-1.6 1.7-2.7v-4.5h-6zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmTelehealth32 = /*#__PURE__*/React.forwardRef(function IbmTelehealth32(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
  })), children);
});
var IbmTelehealth24 = /*#__PURE__*/React.forwardRef(function IbmTelehealth24(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
  })), children);
});
var IbmTelehealth20 = /*#__PURE__*/React.forwardRef(function IbmTelehealth20(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
  })), children);
});
var IbmTelehealth16 = /*#__PURE__*/React.forwardRef(function IbmTelehealth16(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
  })), children);
});
var IbmTenet32 = /*#__PURE__*/React.forwardRef(function IbmTenet32(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
var IbmTenet24 = /*#__PURE__*/React.forwardRef(function IbmTenet24(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
var IbmTenet20 = /*#__PURE__*/React.forwardRef(function IbmTenet20(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
var IbmTenet16 = /*#__PURE__*/React.forwardRef(function IbmTenet16(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
var IbmToolchain32 = /*#__PURE__*/React.forwardRef(function IbmToolchain32(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
  })), children);
});
var IbmToolchain24 = /*#__PURE__*/React.forwardRef(function IbmToolchain24(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
  })), children);
});
var IbmToolchain20 = /*#__PURE__*/React.forwardRef(function IbmToolchain20(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
  })), children);
});
var IbmToolchain16 = /*#__PURE__*/React.forwardRef(function IbmToolchain16(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
  })), children);
});
var IbmTurbonomic32 = /*#__PURE__*/React.forwardRef(function IbmTurbonomic32(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8,23.4c-1,2.3-6,4.6-12.8,4.6-7.7,0-13-2.9-13-5.5,0-2.1,3.6-4.5,9.1-5.2l-.3-2c-6.3.9-10.8,3.7-10.8,7.2,0,4.2,6.6,7.5,15,7.5,7.1,0,12.9-2.4,14.5-5.6l-1.7-1Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5,20.9c-1.2,1-4.2,2.1-8.5,2.1s-7.3-1.1-8.5-2.1l-1.8,1c1.7,2,6.1,3.1,10.2,3.1,4.2,0,8.5-1.1,10.2-3.1l-1.6-1Z"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m16,7c-4.2,0-8.5,1.1-10.2,3.1l1.8,1c1.1-1,4.2-2.1,8.4-2.1s7.3,1.1,8.5,2.1l1.8-1c-1.8-2-6.1-3.1-10.3-3.1Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m31,9.5c0-4.2-6.6-7.5-15-7.5C8.9,2,3.1,4.4,1.5,7.6l1.7,1c1-2.3,6-4.6,12.8-4.6,7.7,0,13,2.9,13,5.5,0,2.1-3.6,4.5-9.1,5.2l.3,2c6.3-.9,10.8-3.7,10.8-7.2Z"
  })), children);
});
var IbmTurbonomic24 = /*#__PURE__*/React.forwardRef(function IbmTurbonomic24(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8,23.4c-1,2.3-6,4.6-12.8,4.6-7.7,0-13-2.9-13-5.5,0-2.1,3.6-4.5,9.1-5.2l-.3-2c-6.3.9-10.8,3.7-10.8,7.2,0,4.2,6.6,7.5,15,7.5,7.1,0,12.9-2.4,14.5-5.6l-1.7-1Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5,20.9c-1.2,1-4.2,2.1-8.5,2.1s-7.3-1.1-8.5-2.1l-1.8,1c1.7,2,6.1,3.1,10.2,3.1,4.2,0,8.5-1.1,10.2-3.1l-1.6-1Z"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m16,7c-4.2,0-8.5,1.1-10.2,3.1l1.8,1c1.1-1,4.2-2.1,8.4-2.1s7.3,1.1,8.5,2.1l1.8-1c-1.8-2-6.1-3.1-10.3-3.1Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m31,9.5c0-4.2-6.6-7.5-15-7.5C8.9,2,3.1,4.4,1.5,7.6l1.7,1c1-2.3,6-4.6,12.8-4.6,7.7,0,13,2.9,13,5.5,0,2.1-3.6,4.5-9.1,5.2l.3,2c6.3-.9,10.8-3.7,10.8-7.2Z"
  })), children);
});
var IbmTurbonomic20 = /*#__PURE__*/React.forwardRef(function IbmTurbonomic20(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8,23.4c-1,2.3-6,4.6-12.8,4.6-7.7,0-13-2.9-13-5.5,0-2.1,3.6-4.5,9.1-5.2l-.3-2c-6.3.9-10.8,3.7-10.8,7.2,0,4.2,6.6,7.5,15,7.5,7.1,0,12.9-2.4,14.5-5.6l-1.7-1Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5,20.9c-1.2,1-4.2,2.1-8.5,2.1s-7.3-1.1-8.5-2.1l-1.8,1c1.7,2,6.1,3.1,10.2,3.1,4.2,0,8.5-1.1,10.2-3.1l-1.6-1Z"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m16,7c-4.2,0-8.5,1.1-10.2,3.1l1.8,1c1.1-1,4.2-2.1,8.4-2.1s7.3,1.1,8.5,2.1l1.8-1c-1.8-2-6.1-3.1-10.3-3.1Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m31,9.5c0-4.2-6.6-7.5-15-7.5C8.9,2,3.1,4.4,1.5,7.6l1.7,1c1-2.3,6-4.6,12.8-4.6,7.7,0,13,2.9,13,5.5,0,2.1-3.6,4.5-9.1,5.2l.3,2c6.3-.9,10.8-3.7,10.8-7.2Z"
  })), children);
});
var IbmTurbonomic16 = /*#__PURE__*/React.forwardRef(function IbmTurbonomic16(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8,23.4c-1,2.3-6,4.6-12.8,4.6-7.7,0-13-2.9-13-5.5,0-2.1,3.6-4.5,9.1-5.2l-.3-2c-6.3.9-10.8,3.7-10.8,7.2,0,4.2,6.6,7.5,15,7.5,7.1,0,12.9-2.4,14.5-5.6l-1.7-1Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5,20.9c-1.2,1-4.2,2.1-8.5,2.1s-7.3-1.1-8.5-2.1l-1.8,1c1.7,2,6.1,3.1,10.2,3.1,4.2,0,8.5-1.1,10.2-3.1l-1.6-1Z"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m16,7c-4.2,0-8.5,1.1-10.2,3.1l1.8,1c1.1-1,4.2-2.1,8.4-2.1s7.3,1.1,8.5,2.1l1.8-1c-1.8-2-6.1-3.1-10.3-3.1Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m31,9.5c0-4.2-6.6-7.5-15-7.5C8.9,2,3.1,4.4,1.5,7.6l1.7,1c1-2.3,6-4.6,12.8-4.6,7.7,0,13,2.9,13,5.5,0,2.1-3.6,4.5-9.1,5.2l.3,2c6.3-.9,10.8-3.7,10.8-7.2Z"
  })), children);
});
var IbmVpnForVpc32 = /*#__PURE__*/React.forwardRef(function IbmVpnForVpc32(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-2c0-1.6499-1.3501-3-3-3s-3 1.3501-3 3v2c-1.1001 0-2 .8999-2 2v4c0 1.1001.8999 2 2 2h6c1.1001 0 2-.8999 2-2v-4c0-1.1001-.8999-2-2-2zm-4-2c0-.5498.45-1 1-1s1 .4502 1 1v2h-2v-2zm4 8h-6v-4h6v4zM7 22.14v-9.14h-2v9.14c-1.72.45-3 2-3 3.86 0 2.21 1.79 4 4 4 1.86 0 3.41-1.28 3.86-3h8.14v-2h-8.14c-.37-1.4-1.46-2.49-2.86-2.86zm-1 5.86c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM30 6c0-2.21-1.79-4-4-4-1.86 0-3.41 1.28-3.86 3h-9.14v2h9.14c.37 1.4 1.46 2.49 2.86 2.86v5.14h2v-5.14c1.72-.45 3-2 3-3.86zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m10,8.5898V2H2v8h6.5901l10.9958,11,1.4141-1.4141-11-10.9961Zm-2-.5898h-4v-4h4v4Z"
  })), children);
});
var IbmVpnForVpc24 = /*#__PURE__*/React.forwardRef(function IbmVpnForVpc24(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-2c0-1.6499-1.3501-3-3-3s-3 1.3501-3 3v2c-1.1001 0-2 .8999-2 2v4c0 1.1001.8999 2 2 2h6c1.1001 0 2-.8999 2-2v-4c0-1.1001-.8999-2-2-2zm-4-2c0-.5498.45-1 1-1s1 .4502 1 1v2h-2v-2zm4 8h-6v-4h6v4zM7 22.14v-9.14h-2v9.14c-1.72.45-3 2-3 3.86 0 2.21 1.79 4 4 4 1.86 0 3.41-1.28 3.86-3h8.14v-2h-8.14c-.37-1.4-1.46-2.49-2.86-2.86zm-1 5.86c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM30 6c0-2.21-1.79-4-4-4-1.86 0-3.41 1.28-3.86 3h-9.14v2h9.14c.37 1.4 1.46 2.49 2.86 2.86v5.14h2v-5.14c1.72-.45 3-2 3-3.86zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m10,8.5898V2H2v8h6.5901l10.9958,11,1.4141-1.4141-11-10.9961Zm-2-.5898h-4v-4h4v4Z"
  })), children);
});
var IbmVpnForVpc20 = /*#__PURE__*/React.forwardRef(function IbmVpnForVpc20(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-2c0-1.6499-1.3501-3-3-3s-3 1.3501-3 3v2c-1.1001 0-2 .8999-2 2v4c0 1.1001.8999 2 2 2h6c1.1001 0 2-.8999 2-2v-4c0-1.1001-.8999-2-2-2zm-4-2c0-.5498.45-1 1-1s1 .4502 1 1v2h-2v-2zm4 8h-6v-4h6v4zM7 22.14v-9.14h-2v9.14c-1.72.45-3 2-3 3.86 0 2.21 1.79 4 4 4 1.86 0 3.41-1.28 3.86-3h8.14v-2h-8.14c-.37-1.4-1.46-2.49-2.86-2.86zm-1 5.86c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM30 6c0-2.21-1.79-4-4-4-1.86 0-3.41 1.28-3.86 3h-9.14v2h9.14c.37 1.4 1.46 2.49 2.86 2.86v5.14h2v-5.14c1.72-.45 3-2 3-3.86zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m10,8.5898V2H2v8h6.5901l10.9958,11,1.4141-1.4141-11-10.9961Zm-2-.5898h-4v-4h4v4Z"
  })), children);
});
var IbmVpnForVpc16 = /*#__PURE__*/React.forwardRef(function IbmVpnForVpc16(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-2c0-1.6499-1.3501-3-3-3s-3 1.3501-3 3v2c-1.1001 0-2 .8999-2 2v4c0 1.1001.8999 2 2 2h6c1.1001 0 2-.8999 2-2v-4c0-1.1001-.8999-2-2-2zm-4-2c0-.5498.45-1 1-1s1 .4502 1 1v2h-2v-2zm4 8h-6v-4h6v4zM7 22.14v-9.14h-2v9.14c-1.72.45-3 2-3 3.86 0 2.21 1.79 4 4 4 1.86 0 3.41-1.28 3.86-3h8.14v-2h-8.14c-.37-1.4-1.46-2.49-2.86-2.86zm-1 5.86c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM30 6c0-2.21-1.79-4-4-4-1.86 0-3.41 1.28-3.86 3h-9.14v2h9.14c.37 1.4 1.46 2.49 2.86 2.86v5.14h2v-5.14c1.72-.45 3-2 3-3.86zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m10,8.5898V2H2v8h6.5901l10.9958,11,1.4141-1.4141-11-10.9961Zm-2-.5898h-4v-4h4v4Z"
  })), children);
});
var IbmVsiOnVpcForRegulatedIndustries32 = /*#__PURE__*/React.forwardRef(function IbmVsiOnVpcForRegulatedIndustries32(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM28 30h-8c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-8-10v8h8v-8h-8zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmVsiOnVpcForRegulatedIndustries24 = /*#__PURE__*/React.forwardRef(function IbmVsiOnVpcForRegulatedIndustries24(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM28 30h-8c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-8-10v8h8v-8h-8zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmVsiOnVpcForRegulatedIndustries20 = /*#__PURE__*/React.forwardRef(function IbmVsiOnVpcForRegulatedIndustries20(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM28 30h-8c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-8-10v8h8v-8h-8zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmVsiOnVpcForRegulatedIndustries16 = /*#__PURE__*/React.forwardRef(function IbmVsiOnVpcForRegulatedIndustries16(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM28 30h-8c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-8-10v8h8v-8h-8zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
var IbmWaziDeploy32 = /*#__PURE__*/React.forwardRef(function IbmWaziDeploy32(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H9V16H7zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM27 23l-1.4199 1.4102 1.5898 1.5898h-7.1699v-3.1421c1.7202-.4473 3-1.9995 3-3.8579 0-2.2056-1.7944-4-4-4s-4 1.7944-4 4c0 1.8584 1.2798 3.4106 3 3.8579v3.1421c0 1.1025.8972 2 2 2h7.1699l-1.5798 1.5801 1.4099 1.4199 4-4-4-4zm-10-4c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2z"
  })), children);
});
var IbmWaziDeploy24 = /*#__PURE__*/React.forwardRef(function IbmWaziDeploy24(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H9V16H7zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM27 23l-1.4199 1.4102 1.5898 1.5898h-7.1699v-3.1421c1.7202-.4473 3-1.9995 3-3.8579 0-2.2056-1.7944-4-4-4s-4 1.7944-4 4c0 1.8584 1.2798 3.4106 3 3.8579v3.1421c0 1.1025.8972 2 2 2h7.1699l-1.5798 1.5801 1.4099 1.4199 4-4-4-4zm-10-4c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2z"
  })), children);
});
var IbmWaziDeploy20 = /*#__PURE__*/React.forwardRef(function IbmWaziDeploy20(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H9V16H7zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM27 23l-1.4199 1.4102 1.5898 1.5898h-7.1699v-3.1421c1.7202-.4473 3-1.9995 3-3.8579 0-2.2056-1.7944-4-4-4s-4 1.7944-4 4c0 1.8584 1.2798 3.4106 3 3.8579v3.1421c0 1.1025.8972 2 2 2h7.1699l-1.5798 1.5801 1.4099 1.4199 4-4-4-4zm-10-4c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2z"
  })), children);
});
var IbmWaziDeploy16 = /*#__PURE__*/React.forwardRef(function IbmWaziDeploy16(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H9V16H7zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM27 23l-1.4199 1.4102 1.5898 1.5898h-7.1699v-3.1421c1.7202-.4473 3-1.9995 3-3.8579 0-2.2056-1.7944-4-4-4s-4 1.7944-4 4c0 1.8584 1.2798 3.4106 3 3.8579v3.1421c0 1.1025.8972 2 2 2h7.1699l-1.5798 1.5801 1.4099 1.4199 4-4-4-4zm-10-4c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2z"
  })), children);
});
var IbmCloud32 = /*#__PURE__*/React.forwardRef(function IbmCloud32(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
  })), children);
});
var IbmCloud24 = /*#__PURE__*/React.forwardRef(function IbmCloud24(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
  })), children);
});
var IbmCloud20 = /*#__PURE__*/React.forwardRef(function IbmCloud20(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
  })), children);
});
var IbmCloud16 = /*#__PURE__*/React.forwardRef(function IbmCloud16(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
  })), children);
});
var IbmCloudAppId32 = /*#__PURE__*/React.forwardRef(function IbmCloudAppId32(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
  })), children);
});
var IbmCloudAppId24 = /*#__PURE__*/React.forwardRef(function IbmCloudAppId24(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
  })), children);
});
var IbmCloudAppId20 = /*#__PURE__*/React.forwardRef(function IbmCloudAppId20(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
  })), children);
});
var IbmCloudAppId16 = /*#__PURE__*/React.forwardRef(function IbmCloudAppId16(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
  })), children);
});
var IbmCloudBareMetalServer32 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServer32(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m26,30H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2Zm-20-6v4h20v-4H6Z"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m26,20H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,14v4h20v-4H6Z"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m26,10H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,4v4h20v-4H6Z"
  })), children);
});
var IbmCloudBareMetalServer24 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServer24(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "m26,30H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2Zm-20-6v4h20v-4H6Z"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m26,20H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,14v4h20v-4H6Z"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m26,10H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,4v4h20v-4H6Z"
  })), children);
});
var IbmCloudBareMetalServer20 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServer20(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m26,30H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2Zm-20-6v4h20v-4H6Z"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m26,20H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,14v4h20v-4H6Z"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m26,10H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,4v4h20v-4H6Z"
  })), children);
});
var IbmCloudBareMetalServer16 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServer16(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m26,30H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2Zm-20-6v4h20v-4H6Z"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m26,20H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,14v4h20v-4H6Z"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m26,10H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,4v4h20v-4H6Z"
  })), children);
});
var IbmCloudBareMetalServersVpc32 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServersVpc32(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24v4c0 1.1.9 2 2 2h12v-2H6v-4h12v-2H6c-1.1 0-2 .9-2 2zM4 13v5c0 1.1.9 2 2 2h8v-2H6v-5h-2z"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19v-5c0-1.1-.9-2-2-2h-8v2h8v5h2zM28 8v-4c0-1.1-.9-2-2-2h-12v2h12v4h-12v2h12c1.1 0 2-.9 2-2z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41,22l-13.41-13.41V2H2v8h6.59l13.41,13.41v6.59h8v-8h-6.59Zm-15.41-14h-4v-4h4v4Zm20,20h-4v-4h4v4Z"
  })), children);
});
var IbmCloudBareMetalServersVpc24 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServersVpc24(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24v4c0 1.1.9 2 2 2h12v-2H6v-4h12v-2H6c-1.1 0-2 .9-2 2zM4 13v5c0 1.1.9 2 2 2h8v-2H6v-5h-2z"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19v-5c0-1.1-.9-2-2-2h-8v2h8v5h2zM28 8v-4c0-1.1-.9-2-2-2h-12v2h12v4h-12v2h12c1.1 0 2-.9 2-2z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41,22l-13.41-13.41V2H2v8h6.59l13.41,13.41v6.59h8v-8h-6.59Zm-15.41-14h-4v-4h4v4Zm20,20h-4v-4h4v4Z"
  })), children);
});
var IbmCloudBareMetalServersVpc20 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServersVpc20(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24v4c0 1.1.9 2 2 2h12v-2H6v-4h12v-2H6c-1.1 0-2 .9-2 2zM4 13v5c0 1.1.9 2 2 2h8v-2H6v-5h-2z"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19v-5c0-1.1-.9-2-2-2h-8v2h8v5h2zM28 8v-4c0-1.1-.9-2-2-2h-12v2h12v4h-12v2h12c1.1 0 2-.9 2-2z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41,22l-13.41-13.41V2H2v8h6.59l13.41,13.41v6.59h8v-8h-6.59Zm-15.41-14h-4v-4h4v4Zm20,20h-4v-4h4v4Z"
  })), children);
});
var IbmCloudBareMetalServersVpc16 = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServersVpc16(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24v4c0 1.1.9 2 2 2h12v-2H6v-4h12v-2H6c-1.1 0-2 .9-2 2zM4 13v5c0 1.1.9 2 2 2h8v-2H6v-5h-2z"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19v-5c0-1.1-.9-2-2-2h-8v2h8v5h2zM28 8v-4c0-1.1-.9-2-2-2h-12v2h12v4h-12v2h12c1.1 0 2-.9 2-2z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41,22l-13.41-13.41V2H2v8h6.59l13.41,13.41v6.59h8v-8h-6.59Zm-15.41-14h-4v-4h4v4Zm20,20h-4v-4h4v4Z"
  })), children);
});
var IbmCloudCitrixDaas32 = /*#__PURE__*/React.forwardRef(function IbmCloudCitrixDaas32(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
  })), children);
});
var IbmCloudCitrixDaas24 = /*#__PURE__*/React.forwardRef(function IbmCloudCitrixDaas24(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
  })), children);
});
var IbmCloudCitrixDaas20 = /*#__PURE__*/React.forwardRef(function IbmCloudCitrixDaas20(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
  })), children);
});
var IbmCloudCitrixDaas16 = /*#__PURE__*/React.forwardRef(function IbmCloudCitrixDaas16(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5\tL9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
  })), children);
});
var IbmCloudContinuousDelivery32 = /*#__PURE__*/React.forwardRef(function IbmCloudContinuousDelivery32(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
  })), children);
});
var IbmCloudContinuousDelivery24 = /*#__PURE__*/React.forwardRef(function IbmCloudContinuousDelivery24(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
  })), children);
});
var IbmCloudContinuousDelivery20 = /*#__PURE__*/React.forwardRef(function IbmCloudContinuousDelivery20(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
  })), children);
});
var IbmCloudContinuousDelivery16 = /*#__PURE__*/React.forwardRef(function IbmCloudContinuousDelivery16(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
  })), children);
});
var IbmCloudDedicatedHost32 = /*#__PURE__*/React.forwardRef(function IbmCloudDedicatedHost32(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
  })), children);
});
var IbmCloudDedicatedHost24 = /*#__PURE__*/React.forwardRef(function IbmCloudDedicatedHost24(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
  })), children);
});
var IbmCloudDedicatedHost20 = /*#__PURE__*/React.forwardRef(function IbmCloudDedicatedHost20(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
  })), children);
});
var IbmCloudDedicatedHost16 = /*#__PURE__*/React.forwardRef(function IbmCloudDedicatedHost16(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
  })), children);
});
var IbmCloudDirectLink_1Connect32 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Connect32(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Connect24 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Connect24(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Connect20 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Connect20(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Connect16 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Connect16(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3\tl4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12\tz M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Dedicated32 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Dedicated32(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Dedicated24 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Dedicated24(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Dedicated20 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Dedicated20(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Dedicated16 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Dedicated16(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1DedicatedHosting32 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1DedicatedHosting32(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1DedicatedHosting24 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1DedicatedHosting24(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1DedicatedHosting20 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1DedicatedHosting20(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1DedicatedHosting16 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1DedicatedHosting16(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Exchange32 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Exchange32(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Exchange24 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Exchange24(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Exchange20 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Exchange20(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_1Exchange16 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Exchange16(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
var IbmCloudDirectLink_2Connect32 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Connect32(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
  })), children);
});
var IbmCloudDirectLink_2Connect24 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Connect24(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
  })), children);
});
var IbmCloudDirectLink_2Connect20 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Connect20(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
  })), children);
});
var IbmCloudDirectLink_2Connect16 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Connect16(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6\tc0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
  })), children);
});
var IbmCloudDirectLink_2Dedicated32 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Dedicated32(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
  })), children);
});
var IbmCloudDirectLink_2Dedicated24 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Dedicated24(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
  })), children);
});
var IbmCloudDirectLink_2Dedicated20 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Dedicated20(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
  })), children);
});
var IbmCloudDirectLink_2Dedicated16 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Dedicated16(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
  })), children);
});
var IbmCloudDirectLink_2DedicatedHosting32 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2DedicatedHosting32(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
  })), children);
});
var IbmCloudDirectLink_2DedicatedHosting24 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2DedicatedHosting24(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
  })), children);
});
var IbmCloudDirectLink_2DedicatedHosting20 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2DedicatedHosting20(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
  })), children);
});
var IbmCloudDirectLink_2DedicatedHosting16 = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2DedicatedHosting16(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
  })), children);
});
var IbmCloudEventNotification32 = /*#__PURE__*/React.forwardRef(function IbmCloudEventNotification32(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
  })), children);
});
var IbmCloudEventNotification24 = /*#__PURE__*/React.forwardRef(function IbmCloudEventNotification24(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
  })), children);
});
var IbmCloudEventNotification20 = /*#__PURE__*/React.forwardRef(function IbmCloudEventNotification20(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
  })), children);
});
var IbmCloudEventNotification16 = /*#__PURE__*/React.forwardRef(function IbmCloudEventNotification16(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8\tC10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23\tc-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6\tc0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6\tc0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23\tc-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
  })), children);
});
var IbmCloudEventStreams32 = /*#__PURE__*/React.forwardRef(function IbmCloudEventStreams32(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
  })), children);
});
var IbmCloudEventStreams24 = /*#__PURE__*/React.forwardRef(function IbmCloudEventStreams24(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
  })), children);
});
var IbmCloudEventStreams20 = /*#__PURE__*/React.forwardRef(function IbmCloudEventStreams20(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
  })), children);
});
var IbmCloudEventStreams16 = /*#__PURE__*/React.forwardRef(function IbmCloudEventStreams16(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6\tV29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3\tC11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8\tc-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4\tC23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1\tS9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
  })), children);
});
var IbmCloudForEducation32 = /*#__PURE__*/React.forwardRef(function IbmCloudForEducation32(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
  })), children);
});
var IbmCloudForEducation24 = /*#__PURE__*/React.forwardRef(function IbmCloudForEducation24(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
  })), children);
});
var IbmCloudForEducation20 = /*#__PURE__*/React.forwardRef(function IbmCloudForEducation20(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
  })), children);
});
var IbmCloudForEducation16 = /*#__PURE__*/React.forwardRef(function IbmCloudForEducation16(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
  })), children);
});
var IbmCloudHpc32 = /*#__PURE__*/React.forwardRef(function IbmCloudHpc32(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H24V15H22zM26 13H28V15H26zM30 13H32V15H30zM30 17H32V19H30zM15 20H17V22H15zM20 28H22V30H20zM24 28H26V30H24zM19 26h9v-9h-9v9zm2-7h5v5h-5v-5z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3v.0005c-.002,0-.004-.0003-.006-.0003-4.7007.0032-8.9033,3.3306-9.8242,8.1152C2.6037,11.7607.0078,14.8598,0,18.4815c-.0089,4.1434,3.345,7.5096,7.4911,7.5185h9.5089v-2H7.4954c-3.0367-.0065-5.502-2.4802-5.4954-5.5142.0057-2.6569,1.9092-4.9289,4.5259-5.4023l1.3488-.2441.2591-1.3459c.7241-3.7623,4.0386-6.4933,7.8662-6.4935h0c3.7363,0,6.9395,2.5367,7.79,6.169l1.9473-.4561c-1.0635-4.541-5.0674-7.7129-9.7373-7.7129Z"
  })), children);
});
var IbmCloudHpc24 = /*#__PURE__*/React.forwardRef(function IbmCloudHpc24(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H24V15H22zM26 13H28V15H26zM30 13H32V15H30zM30 17H32V19H30zM15 20H17V22H15zM20 28H22V30H20zM24 28H26V30H24zM19 26h9v-9h-9v9zm2-7h5v5h-5v-5z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3v.0005c-.002,0-.004-.0003-.006-.0003-4.7007.0032-8.9033,3.3306-9.8242,8.1152C2.6037,11.7607.0078,14.8598,0,18.4815c-.0089,4.1434,3.345,7.5096,7.4911,7.5185h9.5089v-2H7.4954c-3.0367-.0065-5.502-2.4802-5.4954-5.5142.0057-2.6569,1.9092-4.9289,4.5259-5.4023l1.3488-.2441.2591-1.3459c.7241-3.7623,4.0386-6.4933,7.8662-6.4935h0c3.7363,0,6.9395,2.5367,7.79,6.169l1.9473-.4561c-1.0635-4.541-5.0674-7.7129-9.7373-7.7129Z"
  })), children);
});
var IbmCloudHpc20 = /*#__PURE__*/React.forwardRef(function IbmCloudHpc20(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H24V15H22zM26 13H28V15H26zM30 13H32V15H30zM30 17H32V19H30zM15 20H17V22H15zM20 28H22V30H20zM24 28H26V30H24zM19 26h9v-9h-9v9zm2-7h5v5h-5v-5z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3v.0005c-.002,0-.004-.0003-.006-.0003-4.7007.0032-8.9033,3.3306-9.8242,8.1152C2.6037,11.7607.0078,14.8598,0,18.4815c-.0089,4.1434,3.345,7.5096,7.4911,7.5185h9.5089v-2H7.4954c-3.0367-.0065-5.502-2.4802-5.4954-5.5142.0057-2.6569,1.9092-4.9289,4.5259-5.4023l1.3488-.2441.2591-1.3459c.7241-3.7623,4.0386-6.4933,7.8662-6.4935h0c3.7363,0,6.9395,2.5367,7.79,6.169l1.9473-.4561c-1.0635-4.541-5.0674-7.7129-9.7373-7.7129Z"
  })), children);
});
var IbmCloudHpc16 = /*#__PURE__*/React.forwardRef(function IbmCloudHpc16(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H24V15H22zM26 13H28V15H26zM30 13H32V15H30zM30 17H32V19H30zM15 20H17V22H15zM20 28H22V30H20zM24 28H26V30H24zM19 26h9v-9h-9v9zm2-7h5v5h-5v-5z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3v.0005c-.002,0-.004-.0003-.006-.0003-4.7007.0032-8.9033,3.3306-9.8242,8.1152C2.6037,11.7607.0078,14.8598,0,18.4815c-.0089,4.1434,3.345,7.5096,7.4911,7.5185h9.5089v-2H7.4954c-3.0367-.0065-5.502-2.4802-5.4954-5.5142.0057-2.6569,1.9092-4.9289,4.5259-5.4023l1.3488-.2441.2591-1.3459c.7241-3.7623,4.0386-6.4933,7.8662-6.4935h0c3.7363,0,6.9395,2.5367,7.79,6.169l1.9473-.4561c-1.0635-4.541-5.0674-7.7129-9.7373-7.7129Z"
  })), children);
});
var IbmCloudHsm32 = /*#__PURE__*/React.forwardRef(function IbmCloudHsm32(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: "1"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
  })), children);
});
var IbmCloudHsm24 = /*#__PURE__*/React.forwardRef(function IbmCloudHsm24(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: "1"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
  })), children);
});
var IbmCloudHsm20 = /*#__PURE__*/React.forwardRef(function IbmCloudHsm20(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: "1"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
  })), children);
});
var IbmCloudHsm16 = /*#__PURE__*/React.forwardRef(function IbmCloudHsm16(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: "1"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
  })), children);
});
var IbmCloudHyperProtectCryptoServices32 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectCryptoServices32(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
  })), children);
});
var IbmCloudHyperProtectCryptoServices24 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectCryptoServices24(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
  })), children);
});
var IbmCloudHyperProtectCryptoServices20 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectCryptoServices20(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
  })), children);
});
var IbmCloudHyperProtectCryptoServices16 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectCryptoServices16(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23\tL8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3\tc0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
  })), children);
});
var IbmCloudHyperProtectDbaas32 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectDbaas32(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "23",
    r: "1"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "7",
    r: "1"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
  })), children);
});
var IbmCloudHyperProtectDbaas24 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectDbaas24(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "23",
    r: "1"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "7",
    r: "1"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
  })), children);
});
var IbmCloudHyperProtectDbaas20 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectDbaas20(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "23",
    r: "1"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "7",
    r: "1"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
  })), children);
});
var IbmCloudHyperProtectDbaas16 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectDbaas16(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "23",
    r: "1"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "7",
    r: "1"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
  })), children);
});
var IbmCloudHyperProtectVs32 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectVs32(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
  })), children);
});
var IbmCloudHyperProtectVs24 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectVs24(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
  })), children);
});
var IbmCloudHyperProtectVs20 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectVs20(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
  })), children);
});
var IbmCloudHyperProtectVs16 = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectVs16(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8\tl-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26\tl8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
  })), children);
});
var IbmCloudInternetServices32 = /*#__PURE__*/React.forwardRef(function IbmCloudInternetServices32(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
  })), children);
});
var IbmCloudInternetServices24 = /*#__PURE__*/React.forwardRef(function IbmCloudInternetServices24(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
  })), children);
});
var IbmCloudInternetServices20 = /*#__PURE__*/React.forwardRef(function IbmCloudInternetServices20(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
  })), children);
});
var IbmCloudInternetServices16 = /*#__PURE__*/React.forwardRef(function IbmCloudInternetServices16(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7\tc1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3\tc0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1\ts-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1\ts1,0.4,1,1S27.6,26,27,26z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1\tc1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5\tC1,23.6,4.3,27,8.5,27H19V25z"
  })), children);
});
var IbmCloudIpsecVpn32 = /*#__PURE__*/React.forwardRef(function IbmCloudIpsecVpn32(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
  })), children);
});
var IbmCloudIpsecVpn24 = /*#__PURE__*/React.forwardRef(function IbmCloudIpsecVpn24(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
  })), children);
});
var IbmCloudIpsecVpn20 = /*#__PURE__*/React.forwardRef(function IbmCloudIpsecVpn20(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
  })), children);
});
var IbmCloudIpsecVpn16 = /*#__PURE__*/React.forwardRef(function IbmCloudIpsecVpn16(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
  })), children);
});
var IbmCloudKeyProtect32 = /*#__PURE__*/React.forwardRef(function IbmCloudKeyProtect32(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
  })), children);
});
var IbmCloudKeyProtect24 = /*#__PURE__*/React.forwardRef(function IbmCloudKeyProtect24(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
  })), children);
});
var IbmCloudKeyProtect20 = /*#__PURE__*/React.forwardRef(function IbmCloudKeyProtect20(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
  })), children);
});
var IbmCloudKeyProtect16 = /*#__PURE__*/React.forwardRef(function IbmCloudKeyProtect16(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20\tc-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7\tc1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
  })), children);
});
var IbmCloudKubernetesService32 = /*#__PURE__*/React.forwardRef(function IbmCloudKubernetesService32(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })), children);
});
var IbmCloudKubernetesService24 = /*#__PURE__*/React.forwardRef(function IbmCloudKubernetesService24(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })), children);
});
var IbmCloudKubernetesService20 = /*#__PURE__*/React.forwardRef(function IbmCloudKubernetesService20(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })), children);
});
var IbmCloudKubernetesService16 = /*#__PURE__*/React.forwardRef(function IbmCloudKubernetesService16(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9\tc0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9\tl-4-2.4l-4,2.4V18.4z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1\tc0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })), children);
});
var IbmCloudLogging32 = /*#__PURE__*/React.forwardRef(function IbmCloudLogging32(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H24V8H16zM16 2H24V4H16z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudLogging24 = /*#__PURE__*/React.forwardRef(function IbmCloudLogging24(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H24V8H16zM16 2H24V4H16z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudLogging20 = /*#__PURE__*/React.forwardRef(function IbmCloudLogging20(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H24V8H16zM16 2H24V4H16z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudLogging16 = /*#__PURE__*/React.forwardRef(function IbmCloudLogging16(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1\tc-1.3-0.6-2.2-1.7-2.6-3H24.4z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H24V8H16zM16 2H24V4H16z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudMassDataMigration32 = /*#__PURE__*/React.forwardRef(function IbmCloudMassDataMigration32(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmCloudMassDataMigration24 = /*#__PURE__*/React.forwardRef(function IbmCloudMassDataMigration24(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmCloudMassDataMigration20 = /*#__PURE__*/React.forwardRef(function IbmCloudMassDataMigration20(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmCloudMassDataMigration16 = /*#__PURE__*/React.forwardRef(function IbmCloudMassDataMigration16(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmCloudPal32 = /*#__PURE__*/React.forwardRef(function IbmCloudPal32(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30.5093,17.6895l-6-3.5498c-.1572-.0933-.333-.1396-.5093-.1396s-.3521.0464-.5093.1396l-6,3.5498c-.3042.1797-.4907.5068-.4907.8604v6.9004c0,.3535.1865.6807.4907.8604l6,3.5498c.1572.0933.333.1396.5093.1396s.3521-.0464.5093-.1396l6-3.5498c.3042-.1797.4907-.5068.4907-.8604v-6.9004c0-.3535-.1865-.6807-.4907-.8604Zm-1.5093,7.1904l-5,2.958-5-2.958v-5.7598l5-2.958,5,2.958v5.7598Z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14,26h-5c-4.4111,0-8-3.5889-8-8,0-3.7183,2.5986-6.9365,6.1577-7.7783.8438-4.7368,4.9497-8.2217,9.8423-8.2217,5.5137,0,10,4.4858,10,10h-2c0-4.4111-3.5889-8-8-8-4.1177,0-7.5386,3.084-7.9575,7.1743l-.0801.7822-.7793.1064c-2.9551.4033-5.1831,2.9556-5.1831,5.937,0,3.3086,2.6914,6,6,6h5v2Z"
  })), children);
});
var IbmCloudPal24 = /*#__PURE__*/React.forwardRef(function IbmCloudPal24(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30.5093,17.6895l-6-3.5498c-.1572-.0933-.333-.1396-.5093-.1396s-.3521.0464-.5093.1396l-6,3.5498c-.3042.1797-.4907.5068-.4907.8604v6.9004c0,.3535.1865.6807.4907.8604l6,3.5498c.1572.0933.333.1396.5093.1396s.3521-.0464.5093-.1396l6-3.5498c.3042-.1797.4907-.5068.4907-.8604v-6.9004c0-.3535-.1865-.6807-.4907-.8604Zm-1.5093,7.1904l-5,2.958-5-2.958v-5.7598l5-2.958,5,2.958v5.7598Z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14,26h-5c-4.4111,0-8-3.5889-8-8,0-3.7183,2.5986-6.9365,6.1577-7.7783.8438-4.7368,4.9497-8.2217,9.8423-8.2217,5.5137,0,10,4.4858,10,10h-2c0-4.4111-3.5889-8-8-8-4.1177,0-7.5386,3.084-7.9575,7.1743l-.0801.7822-.7793.1064c-2.9551.4033-5.1831,2.9556-5.1831,5.937,0,3.3086,2.6914,6,6,6h5v2Z"
  })), children);
});
var IbmCloudPal20 = /*#__PURE__*/React.forwardRef(function IbmCloudPal20(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30.5093,17.6895l-6-3.5498c-.1572-.0933-.333-.1396-.5093-.1396s-.3521.0464-.5093.1396l-6,3.5498c-.3042.1797-.4907.5068-.4907.8604v6.9004c0,.3535.1865.6807.4907.8604l6,3.5498c.1572.0933.333.1396.5093.1396s.3521-.0464.5093-.1396l6-3.5498c.3042-.1797.4907-.5068.4907-.8604v-6.9004c0-.3535-.1865-.6807-.4907-.8604Zm-1.5093,7.1904l-5,2.958-5-2.958v-5.7598l5-2.958,5,2.958v5.7598Z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14,26h-5c-4.4111,0-8-3.5889-8-8,0-3.7183,2.5986-6.9365,6.1577-7.7783.8438-4.7368,4.9497-8.2217,9.8423-8.2217,5.5137,0,10,4.4858,10,10h-2c0-4.4111-3.5889-8-8-8-4.1177,0-7.5386,3.084-7.9575,7.1743l-.0801.7822-.7793.1064c-2.9551.4033-5.1831,2.9556-5.1831,5.937,0,3.3086,2.6914,6,6,6h5v2Z"
  })), children);
});
var IbmCloudPal16 = /*#__PURE__*/React.forwardRef(function IbmCloudPal16(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30.5093,17.6895l-6-3.5498c-.1572-.0933-.333-.1396-.5093-.1396s-.3521.0464-.5093.1396l-6,3.5498c-.3042.1797-.4907.5068-.4907.8604v6.9004c0,.3535.1865.6807.4907.8604l6,3.5498c.1572.0933.333.1396.5093.1396s.3521-.0464.5093-.1396l6-3.5498c.3042-.1797.4907-.5068.4907-.8604v-6.9004c0-.3535-.1865-.6807-.4907-.8604Zm-1.5093,7.1904l-5,2.958-5-2.958v-5.7598l5-2.958,5,2.958v5.7598Z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14,26h-5c-4.4111,0-8-3.5889-8-8,0-3.7183,2.5986-6.9365,6.1577-7.7783.8438-4.7368,4.9497-8.2217,9.8423-8.2217,5.5137,0,10,4.4858,10,10h-2c0-4.4111-3.5889-8-8-8-4.1177,0-7.5386,3.084-7.9575,7.1743l-.0801.7822-.7793.1064c-2.9551.4033-5.1831,2.9556-5.1831,5.937,0,3.3086,2.6914,6,6,6h5v2Z"
  })), children);
});
var IbmCloudPrivilegedAccessGateway32 = /*#__PURE__*/React.forwardRef(function IbmCloudPrivilegedAccessGateway32(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
  })), children);
});
var IbmCloudPrivilegedAccessGateway24 = /*#__PURE__*/React.forwardRef(function IbmCloudPrivilegedAccessGateway24(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
  })), children);
});
var IbmCloudPrivilegedAccessGateway20 = /*#__PURE__*/React.forwardRef(function IbmCloudPrivilegedAccessGateway20(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
  })), children);
});
var IbmCloudPrivilegedAccessGateway16 = /*#__PURE__*/React.forwardRef(function IbmCloudPrivilegedAccessGateway16(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4\tH8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3\tv4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4\tC26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7\tc-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
  })), children);
});
var IbmCloudProjects32 = /*#__PURE__*/React.forwardRef(function IbmCloudProjects32(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18h-10v6.4678c0 1.9229 1.1231 3.6973 2.8613 4.5195l2.1387 1.0127 2.1387-1.0127c1.7383-.8223 2.8613-2.5967 2.8613-4.5195v-6.4678h0zm-5 9.7861l-1.2832-.6074c-1.043-.4932-1.7168-1.5576-1.7168-2.7109v-4.4678h6v4.4678c0 1.1533-.6738 2.2178-1.7168 2.7109l-1.2832.6074h0zM17 18H5c-1.1045 0-2 .8954-2 2v5c0 1.1045.8955 2 2 2h12v-2H5v-5h12v-2h0zM27 4h-5c-1.1045 0-2 .8954-2 2v9h2V6h5v9h2V6c0-1.1046-.8955-2-2-2h0zM15 4H5c-1.1045 0-2 .8954-2 2v7c0 1.1045.8955 2 2 2h10c1.1045 0 2-.8955 2-2v-7c0-1.1046-.8955-2-2-2h0zM5 13v-7h10v7H5z"
  })), children);
});
var IbmCloudProjects24 = /*#__PURE__*/React.forwardRef(function IbmCloudProjects24(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18h-10v6.4678c0 1.9229 1.1231 3.6973 2.8613 4.5195l2.1387 1.0127 2.1387-1.0127c1.7383-.8223 2.8613-2.5967 2.8613-4.5195v-6.4678h0zm-5 9.7861l-1.2832-.6074c-1.043-.4932-1.7168-1.5576-1.7168-2.7109v-4.4678h6v4.4678c0 1.1533-.6738 2.2178-1.7168 2.7109l-1.2832.6074h0zM17 18H5c-1.1045 0-2 .8954-2 2v5c0 1.1045.8955 2 2 2h12v-2H5v-5h12v-2h0zM27 4h-5c-1.1045 0-2 .8954-2 2v9h2V6h5v9h2V6c0-1.1046-.8955-2-2-2h0zM15 4H5c-1.1045 0-2 .8954-2 2v7c0 1.1045.8955 2 2 2h10c1.1045 0 2-.8955 2-2v-7c0-1.1046-.8955-2-2-2h0zM5 13v-7h10v7H5z"
  })), children);
});
var IbmCloudProjects20 = /*#__PURE__*/React.forwardRef(function IbmCloudProjects20(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18h-10v6.4678c0 1.9229 1.1231 3.6973 2.8613 4.5195l2.1387 1.0127 2.1387-1.0127c1.7383-.8223 2.8613-2.5967 2.8613-4.5195v-6.4678h0zm-5 9.7861l-1.2832-.6074c-1.043-.4932-1.7168-1.5576-1.7168-2.7109v-4.4678h6v4.4678c0 1.1533-.6738 2.2178-1.7168 2.7109l-1.2832.6074h0zM17 18H5c-1.1045 0-2 .8954-2 2v5c0 1.1045.8955 2 2 2h12v-2H5v-5h12v-2h0zM27 4h-5c-1.1045 0-2 .8954-2 2v9h2V6h5v9h2V6c0-1.1046-.8955-2-2-2h0zM15 4H5c-1.1045 0-2 .8954-2 2v7c0 1.1045.8955 2 2 2h10c1.1045 0 2-.8955 2-2v-7c0-1.1046-.8955-2-2-2h0zM5 13v-7h10v7H5z"
  })), children);
});
var IbmCloudProjects16 = /*#__PURE__*/React.forwardRef(function IbmCloudProjects16(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18h-10v6.4678c0 1.9229 1.1231 3.6973 2.8613 4.5195l2.1387 1.0127 2.1387-1.0127c1.7383-.8223 2.8613-2.5967 2.8613-4.5195v-6.4678h0zm-5 9.7861l-1.2832-.6074c-1.043-.4932-1.7168-1.5576-1.7168-2.7109v-4.4678h6v4.4678c0 1.1533-.6738 2.2178-1.7168 2.7109l-1.2832.6074h0zM17 18H5c-1.1045 0-2 .8954-2 2v5c0 1.1045.8955 2 2 2h12v-2H5v-5h12v-2h0zM27 4h-5c-1.1045 0-2 .8954-2 2v9h2V6h5v9h2V6c0-1.1046-.8955-2-2-2h0zM15 4H5c-1.1045 0-2 .8954-2 2v7c0 1.1045.8955 2 2 2h10c1.1045 0 2-.8955 2-2v-7c0-1.1046-.8955-2-2-2h0zM5 13v-7h10v7H5z"
  })), children);
});
var IbmCloudResiliency32 = /*#__PURE__*/React.forwardRef(function IbmCloudResiliency32(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24v6h6v-6h-6zm4 4h-2v-2h2v2zM2 30h6v-6H2v6zm2-4h2v2h-2v-2z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15h-9v-6.1631c1.4407-.4336 2.5-1.7571 2.5-3.3369 0-1.9297-1.5703-3.5-3.5-3.5s-3.5 1.5703-3.5 3.5c0 1.5798 1.0593 2.9033 2.5 3.3369v6.1631H6c-1.1025 0-2 .8972-2 2v5h2v-5h9v7h-2v6h6v-6h-2v-7h9v5h2v-5c0-1.1028-.8975-2-2-2zM14.5 5.5c0-.8271.6729-1.5 1.5-1.5s1.5.6729 1.5 1.5-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5zm2.5 22.5h-2v-2h2v2zM26.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5zM5.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5z"
  })), children);
});
var IbmCloudResiliency24 = /*#__PURE__*/React.forwardRef(function IbmCloudResiliency24(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24v6h6v-6h-6zm4 4h-2v-2h2v2zM2 30h6v-6H2v6zm2-4h2v2h-2v-2z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15h-9v-6.1631c1.4407-.4336 2.5-1.7571 2.5-3.3369 0-1.9297-1.5703-3.5-3.5-3.5s-3.5 1.5703-3.5 3.5c0 1.5798 1.0593 2.9033 2.5 3.3369v6.1631H6c-1.1025 0-2 .8972-2 2v5h2v-5h9v7h-2v6h6v-6h-2v-7h9v5h2v-5c0-1.1028-.8975-2-2-2zM14.5 5.5c0-.8271.6729-1.5 1.5-1.5s1.5.6729 1.5 1.5-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5zm2.5 22.5h-2v-2h2v2zM26.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5zM5.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5z"
  })), children);
});
var IbmCloudResiliency20 = /*#__PURE__*/React.forwardRef(function IbmCloudResiliency20(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24v6h6v-6h-6zm4 4h-2v-2h2v2zM2 30h6v-6H2v6zm2-4h2v2h-2v-2z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15h-9v-6.1631c1.4407-.4336 2.5-1.7571 2.5-3.3369 0-1.9297-1.5703-3.5-3.5-3.5s-3.5 1.5703-3.5 3.5c0 1.5798 1.0593 2.9033 2.5 3.3369v6.1631H6c-1.1025 0-2 .8972-2 2v5h2v-5h9v7h-2v6h6v-6h-2v-7h9v5h2v-5c0-1.1028-.8975-2-2-2zM14.5 5.5c0-.8271.6729-1.5 1.5-1.5s1.5.6729 1.5 1.5-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5zm2.5 22.5h-2v-2h2v2zM26.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5zM5.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5z"
  })), children);
});
var IbmCloudResiliency16 = /*#__PURE__*/React.forwardRef(function IbmCloudResiliency16(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24v6h6v-6h-6zm4 4h-2v-2h2v2zM2 30h6v-6H2v6zm2-4h2v2h-2v-2z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15h-9v-6.1631c1.4407-.4336 2.5-1.7571 2.5-3.3369 0-1.9297-1.5703-3.5-3.5-3.5s-3.5 1.5703-3.5 3.5c0 1.5798 1.0593 2.9033 2.5 3.3369v6.1631H6c-1.1025 0-2 .8972-2 2v5h2v-5h9v7h-2v6h6v-6h-2v-7h9v5h2v-5c0-1.1028-.8975-2-2-2zM14.5 5.5c0-.8271.6729-1.5 1.5-1.5s1.5.6729 1.5 1.5-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5zm2.5 22.5h-2v-2h2v2zM26.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5zM5.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5z"
  })), children);
});
var IbmCloudSecretsManager32 = /*#__PURE__*/React.forwardRef(function IbmCloudSecretsManager32(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
  })), children);
});
var IbmCloudSecretsManager24 = /*#__PURE__*/React.forwardRef(function IbmCloudSecretsManager24(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
  })), children);
});
var IbmCloudSecretsManager20 = /*#__PURE__*/React.forwardRef(function IbmCloudSecretsManager20(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
  })), children);
});
var IbmCloudSecretsManager16 = /*#__PURE__*/React.forwardRef(function IbmCloudSecretsManager16(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4\tl3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3\tl1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6\tC9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
  })), children);
});
var IbmCloudSecurityComplianceCenter32 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenter32(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
  })), children);
});
var IbmCloudSecurityComplianceCenter24 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenter24(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
  })), children);
});
var IbmCloudSecurityComplianceCenter20 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenter20(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
  })), children);
});
var IbmCloudSecurityComplianceCenter16 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenter16(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8\tL24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8\tc-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
  })), children);
});
var IbmCloudSecurityComplianceCenterWorkloadProtection32 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenterWorkloadProtection32(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v6.5c0 1.9 1.1 3.7 2.9 4.5l2.1 1 2.1-1c1.7-.8 2.9-2.6 2.9-4.5V18H20zM28 24.5c0 1.2-.7 2.2-1.7 2.7L25 27.8l-1.3-.6c-1-.5-1.7-1.6-1.7-2.7V20h6V24.5zM16 20c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4h-2c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2V20z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-5,0-9-4-9-9s4-9,9-9s9,4,9,9h-2c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7V25z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14h-2c0-6.6-5.4-12-12-12S4,9.4,4,16s5.4,12,12,12V30z"
  })), children);
});
var IbmCloudSecurityComplianceCenterWorkloadProtection24 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenterWorkloadProtection24(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v6.5c0 1.9 1.1 3.7 2.9 4.5l2.1 1 2.1-1c1.7-.8 2.9-2.6 2.9-4.5V18H20zM28 24.5c0 1.2-.7 2.2-1.7 2.7L25 27.8l-1.3-.6c-1-.5-1.7-1.6-1.7-2.7V20h6V24.5zM16 20c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4h-2c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2V20z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-5,0-9-4-9-9s4-9,9-9s9,4,9,9h-2c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7V25z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14h-2c0-6.6-5.4-12-12-12S4,9.4,4,16s5.4,12,12,12V30z"
  })), children);
});
var IbmCloudSecurityComplianceCenterWorkloadProtection20 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenterWorkloadProtection20(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v6.5c0 1.9 1.1 3.7 2.9 4.5l2.1 1 2.1-1c1.7-.8 2.9-2.6 2.9-4.5V18H20zM28 24.5c0 1.2-.7 2.2-1.7 2.7L25 27.8l-1.3-.6c-1-.5-1.7-1.6-1.7-2.7V20h6V24.5zM16 20c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4h-2c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2V20z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-5,0-9-4-9-9s4-9,9-9s9,4,9,9h-2c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7V25z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14h-2c0-6.6-5.4-12-12-12S4,9.4,4,16s5.4,12,12,12V30z"
  })), children);
});
var IbmCloudSecurityComplianceCenterWorkloadProtection16 = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenterWorkloadProtection16(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v6.5c0 1.9 1.1 3.7 2.9 4.5l2.1 1 2.1-1c1.7-.8 2.9-2.6 2.9-4.5V18H20zM28 24.5c0 1.2-.7 2.2-1.7 2.7L25 27.8l-1.3-.6c-1-.5-1.7-1.6-1.7-2.7V20h6V24.5zM16 20c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4h-2c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2V20z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-5,0-9-4-9-9s4-9,9-9s9,4,9,9h-2c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7V25z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14h-2c0-6.6-5.4-12-12-12S4,9.4,4,16s5.4,12,12,12V30z"
  })), children);
});
var IbmCloudSubnets32 = /*#__PURE__*/React.forwardRef(function IbmCloudSubnets32(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
  })), children);
});
var IbmCloudSubnets24 = /*#__PURE__*/React.forwardRef(function IbmCloudSubnets24(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
  })), children);
});
var IbmCloudSubnets20 = /*#__PURE__*/React.forwardRef(function IbmCloudSubnets20(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
  })), children);
});
var IbmCloudSubnets16 = /*#__PURE__*/React.forwardRef(function IbmCloudSubnets16(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
  })), children);
});
var IbmCloudSysdigSecure32 = /*#__PURE__*/React.forwardRef(function IbmCloudSysdigSecure32(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudSysdigSecure24 = /*#__PURE__*/React.forwardRef(function IbmCloudSysdigSecure24(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudSysdigSecure20 = /*#__PURE__*/React.forwardRef(function IbmCloudSysdigSecure20(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudSysdigSecure16 = /*#__PURE__*/React.forwardRef(function IbmCloudSysdigSecure16(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6\tl1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
var IbmCloudTransitGateway32 = /*#__PURE__*/React.forwardRef(function IbmCloudTransitGateway32(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5l-1.4-1.4 3.5-3.5c.8-.8 2.1-.8 2.8 0l3.5 3.5-1.4 1.4-3.5-3.5-3.5 3.5zM19.5 24.5l1.4 1.4-3.5 3.5c-.8.8-2.1.8-2.8 0l-3.5-3.5 1.4-1.4 3.5 3.5 3.5-3.5zM24.5 12.5l1.4-1.4 3.5 3.5c.8.8.8 2.1 0 2.8l-3.5 3.5-1.4-1.4 3.5-3.5-3.5-3.5zM7.5 19.5l-1.4 1.4-3.5-3.5c-.8-.8-.8-2.1 0-2.8l3.5-3.5 1.4 1.4-3.5 3.5 3.5 3.5z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-.2,0-.3,0-.5.1l-6.1-6.1c.8-1.2.8-2.8,0-4l6.1-6.1c.2.1.3.1.5.1,1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2c0,.2,0,.3.1.5l-6.1,6.1c-1.2-.8-2.8-.8-4,0l-6.1-6.1c.1-.2.1-.3.1-.5,0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2c.2,0,.3,0,.5-.1l6.1,6.1c-.8,1.2-.8,2.8,0,4l-6.1,6.1c-.2-.1-.3-.1-.5-.1-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c0-.2,0-.3-.1-.5l6.1-6.1c1.2.8,2.8.8,4,0l6.1,6.1c0,.2-.1.3-.1.5,0,1.1.9,2,2,2s2-.9,2-2-.9-2-2-2Zm-10-6c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })), children);
});
var IbmCloudTransitGateway24 = /*#__PURE__*/React.forwardRef(function IbmCloudTransitGateway24(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5l-1.4-1.4 3.5-3.5c.8-.8 2.1-.8 2.8 0l3.5 3.5-1.4 1.4-3.5-3.5-3.5 3.5zM19.5 24.5l1.4 1.4-3.5 3.5c-.8.8-2.1.8-2.8 0l-3.5-3.5 1.4-1.4 3.5 3.5 3.5-3.5zM24.5 12.5l1.4-1.4 3.5 3.5c.8.8.8 2.1 0 2.8l-3.5 3.5-1.4-1.4 3.5-3.5-3.5-3.5zM7.5 19.5l-1.4 1.4-3.5-3.5c-.8-.8-.8-2.1 0-2.8l3.5-3.5 1.4 1.4-3.5 3.5 3.5 3.5z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-.2,0-.3,0-.5.1l-6.1-6.1c.8-1.2.8-2.8,0-4l6.1-6.1c.2.1.3.1.5.1,1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2c0,.2,0,.3.1.5l-6.1,6.1c-1.2-.8-2.8-.8-4,0l-6.1-6.1c.1-.2.1-.3.1-.5,0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2c.2,0,.3,0,.5-.1l6.1,6.1c-.8,1.2-.8,2.8,0,4l-6.1,6.1c-.2-.1-.3-.1-.5-.1-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c0-.2,0-.3-.1-.5l6.1-6.1c1.2.8,2.8.8,4,0l6.1,6.1c0,.2-.1.3-.1.5,0,1.1.9,2,2,2s2-.9,2-2-.9-2-2-2Zm-10-6c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })), children);
});
var IbmCloudTransitGateway20 = /*#__PURE__*/React.forwardRef(function IbmCloudTransitGateway20(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5l-1.4-1.4 3.5-3.5c.8-.8 2.1-.8 2.8 0l3.5 3.5-1.4 1.4-3.5-3.5-3.5 3.5zM19.5 24.5l1.4 1.4-3.5 3.5c-.8.8-2.1.8-2.8 0l-3.5-3.5 1.4-1.4 3.5 3.5 3.5-3.5zM24.5 12.5l1.4-1.4 3.5 3.5c.8.8.8 2.1 0 2.8l-3.5 3.5-1.4-1.4 3.5-3.5-3.5-3.5zM7.5 19.5l-1.4 1.4-3.5-3.5c-.8-.8-.8-2.1 0-2.8l3.5-3.5 1.4 1.4-3.5 3.5 3.5 3.5z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-.2,0-.3,0-.5.1l-6.1-6.1c.8-1.2.8-2.8,0-4l6.1-6.1c.2.1.3.1.5.1,1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2c0,.2,0,.3.1.5l-6.1,6.1c-1.2-.8-2.8-.8-4,0l-6.1-6.1c.1-.2.1-.3.1-.5,0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2c.2,0,.3,0,.5-.1l6.1,6.1c-.8,1.2-.8,2.8,0,4l-6.1,6.1c-.2-.1-.3-.1-.5-.1-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c0-.2,0-.3-.1-.5l6.1-6.1c1.2.8,2.8.8,4,0l6.1,6.1c0,.2-.1.3-.1.5,0,1.1.9,2,2,2s2-.9,2-2-.9-2-2-2Zm-10-6c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })), children);
});
var IbmCloudTransitGateway16 = /*#__PURE__*/React.forwardRef(function IbmCloudTransitGateway16(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5l-1.4-1.4 3.5-3.5c.8-.8 2.1-.8 2.8 0l3.5 3.5-1.4 1.4-3.5-3.5-3.5 3.5zM19.5 24.5l1.4 1.4-3.5 3.5c-.8.8-2.1.8-2.8 0l-3.5-3.5 1.4-1.4 3.5 3.5 3.5-3.5zM24.5 12.5l1.4-1.4 3.5 3.5c.8.8.8 2.1 0 2.8l-3.5 3.5-1.4-1.4 3.5-3.5-3.5-3.5zM7.5 19.5l-1.4 1.4-3.5-3.5c-.8-.8-.8-2.1 0-2.8l3.5-3.5 1.4 1.4-3.5 3.5 3.5 3.5z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-.2,0-.3,0-.5.1l-6.1-6.1c.8-1.2.8-2.8,0-4l6.1-6.1c.2.1.3.1.5.1,1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2c0,.2,0,.3.1.5l-6.1,6.1c-1.2-.8-2.8-.8-4,0l-6.1-6.1c.1-.2.1-.3.1-.5,0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2c.2,0,.3,0,.5-.1l6.1,6.1c-.8,1.2-.8,2.8,0,4l-6.1,6.1c-.2-.1-.3-.1-.5-.1-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c0-.2,0-.3-.1-.5l6.1-6.1c1.2.8,2.8.8,4,0l6.1,6.1c0,.2-.1.3-.1.5,0,1.1.9,2,2,2s2-.9,2-2-.9-2-2-2Zm-10-6c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })), children);
});
var IbmCloudVirtualServerClassic32 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerClassic32(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22h-5v2h5v4H6v-4h9c1.1,0,2-.9,2-2h0v-9.17l2.59,2.59,1.41-1.42-5-5-5,5,1.41,1.41,2.59-2.58v9.17H6c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h20c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2Z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "m23.75,8.05c-.88-3.5-4.08-6.05-7.75-6.05s-6.87,2.55-7.75,6.05c-2.96.37-5.25,2.9-5.25,5.95,0,3.31,2.69,6,6,6h2v-2h-2c-2.21,0-4-1.79-4-4,0-2.19,1.77-3.97,3.95-4l.99.02.12-.88c.43-2.93,2.98-5.14,5.94-5.14s5.51,2.21,5.93,5.15l.12.88.88-.02.13-.01c2.18.03,3.94,1.81,3.94,4,0,2.21-1.79,4-4,4h-2v2h2c3.31,0,6-2.69,6-6,0-3.05-2.29-5.58-5.25-5.95Z"
  })), children);
});

export { IbmCloud16, IbmCloud20, IbmCloud24, IbmCloud32, IbmCloudAppId16, IbmCloudAppId20, IbmCloudAppId24, IbmCloudAppId32, IbmCloudBareMetalServer16, IbmCloudBareMetalServer20, IbmCloudBareMetalServer24, IbmCloudBareMetalServer32, IbmCloudBareMetalServersVpc16, IbmCloudBareMetalServersVpc20, IbmCloudBareMetalServersVpc24, IbmCloudBareMetalServersVpc32, IbmCloudCitrixDaas16, IbmCloudCitrixDaas20, IbmCloudCitrixDaas24, IbmCloudCitrixDaas32, IbmCloudContinuousDelivery16, IbmCloudContinuousDelivery20, IbmCloudContinuousDelivery24, IbmCloudContinuousDelivery32, IbmCloudDedicatedHost16, IbmCloudDedicatedHost20, IbmCloudDedicatedHost24, IbmCloudDedicatedHost32, IbmCloudDirectLink_1Connect16, IbmCloudDirectLink_1Connect20, IbmCloudDirectLink_1Connect24, IbmCloudDirectLink_1Connect32, IbmCloudDirectLink_1Dedicated16, IbmCloudDirectLink_1Dedicated20, IbmCloudDirectLink_1Dedicated24, IbmCloudDirectLink_1Dedicated32, IbmCloudDirectLink_1DedicatedHosting16, IbmCloudDirectLink_1DedicatedHosting20, IbmCloudDirectLink_1DedicatedHosting24, IbmCloudDirectLink_1DedicatedHosting32, IbmCloudDirectLink_1Exchange16, IbmCloudDirectLink_1Exchange20, IbmCloudDirectLink_1Exchange24, IbmCloudDirectLink_1Exchange32, IbmCloudDirectLink_2Connect16, IbmCloudDirectLink_2Connect20, IbmCloudDirectLink_2Connect24, IbmCloudDirectLink_2Connect32, IbmCloudDirectLink_2Dedicated16, IbmCloudDirectLink_2Dedicated20, IbmCloudDirectLink_2Dedicated24, IbmCloudDirectLink_2Dedicated32, IbmCloudDirectLink_2DedicatedHosting16, IbmCloudDirectLink_2DedicatedHosting20, IbmCloudDirectLink_2DedicatedHosting24, IbmCloudDirectLink_2DedicatedHosting32, IbmCloudEventNotification16, IbmCloudEventNotification20, IbmCloudEventNotification24, IbmCloudEventNotification32, IbmCloudEventStreams16, IbmCloudEventStreams20, IbmCloudEventStreams24, IbmCloudEventStreams32, IbmCloudForEducation16, IbmCloudForEducation20, IbmCloudForEducation24, IbmCloudForEducation32, IbmCloudHpc16, IbmCloudHpc20, IbmCloudHpc24, IbmCloudHpc32, IbmCloudHsm16, IbmCloudHsm20, IbmCloudHsm24, IbmCloudHsm32, IbmCloudHyperProtectCryptoServices16, IbmCloudHyperProtectCryptoServices20, IbmCloudHyperProtectCryptoServices24, IbmCloudHyperProtectCryptoServices32, IbmCloudHyperProtectDbaas16, IbmCloudHyperProtectDbaas20, IbmCloudHyperProtectDbaas24, IbmCloudHyperProtectDbaas32, IbmCloudHyperProtectVs16, IbmCloudHyperProtectVs20, IbmCloudHyperProtectVs24, IbmCloudHyperProtectVs32, IbmCloudInternetServices16, IbmCloudInternetServices20, IbmCloudInternetServices24, IbmCloudInternetServices32, IbmCloudIpsecVpn16, IbmCloudIpsecVpn20, IbmCloudIpsecVpn24, IbmCloudIpsecVpn32, IbmCloudKeyProtect16, IbmCloudKeyProtect20, IbmCloudKeyProtect24, IbmCloudKeyProtect32, IbmCloudKubernetesService16, IbmCloudKubernetesService20, IbmCloudKubernetesService24, IbmCloudKubernetesService32, IbmCloudLogging16, IbmCloudLogging20, IbmCloudLogging24, IbmCloudLogging32, IbmCloudMassDataMigration16, IbmCloudMassDataMigration20, IbmCloudMassDataMigration24, IbmCloudMassDataMigration32, IbmCloudPal16, IbmCloudPal20, IbmCloudPal24, IbmCloudPal32, IbmCloudPrivilegedAccessGateway16, IbmCloudPrivilegedAccessGateway20, IbmCloudPrivilegedAccessGateway24, IbmCloudPrivilegedAccessGateway32, IbmCloudProjects16, IbmCloudProjects20, IbmCloudProjects24, IbmCloudProjects32, IbmCloudResiliency16, IbmCloudResiliency20, IbmCloudResiliency24, IbmCloudResiliency32, IbmCloudSecretsManager16, IbmCloudSecretsManager20, IbmCloudSecretsManager24, IbmCloudSecretsManager32, IbmCloudSecurityComplianceCenter16, IbmCloudSecurityComplianceCenter20, IbmCloudSecurityComplianceCenter24, IbmCloudSecurityComplianceCenter32, IbmCloudSecurityComplianceCenterWorkloadProtection16, IbmCloudSecurityComplianceCenterWorkloadProtection20, IbmCloudSecurityComplianceCenterWorkloadProtection24, IbmCloudSecurityComplianceCenterWorkloadProtection32, IbmCloudSubnets16, IbmCloudSubnets20, IbmCloudSubnets24, IbmCloudSubnets32, IbmCloudSysdigSecure16, IbmCloudSysdigSecure20, IbmCloudSysdigSecure24, IbmCloudSysdigSecure32, IbmCloudTransitGateway16, IbmCloudTransitGateway20, IbmCloudTransitGateway24, IbmCloudTransitGateway32, IbmCloudVirtualServerClassic32, IbmEventAutomation16, IbmEventEndpointMgmt16, IbmEventEndpointMgmt20, IbmEventEndpointMgmt24, IbmEventEndpointMgmt32, IbmEventProcessing16, IbmEventProcessing20, IbmEventProcessing24, IbmEventProcessing32, IbmEventStreams16, IbmEventStreams20, IbmEventStreams24, IbmEventStreams32, IbmIbv16, IbmIbv20, IbmIbv24, IbmIbv32, IbmInstana16, IbmInstana20, IbmInstana24, IbmInstana32, IbmMatch_36016, IbmMatch_36020, IbmMatch_36024, IbmMatch_36032, IbmMq16, IbmMq20, IbmMq24, IbmMq32, IbmOpenEnterpriseLanguages16, IbmOpenEnterpriseLanguages20, IbmOpenEnterpriseLanguages24, IbmOpenEnterpriseLanguages32, IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries16, IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries20, IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries24, IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries32, IbmPowerVs16, IbmPowerVs20, IbmPowerVs24, IbmPowerVs32, IbmPowerVsPrivateCloud16, IbmPowerVsPrivateCloud20, IbmPowerVsPrivateCloud24, IbmPowerVsPrivateCloud32, IbmPowerWithVpc16, IbmPowerWithVpc20, IbmPowerWithVpc24, IbmPowerWithVpc32, IbmPrivatePathServices16, IbmPrivatePathServices20, IbmPrivatePathServices24, IbmPrivatePathServices32, IbmProcessMining16, IbmProcessMining20, IbmProcessMining24, IbmProcessMining32, IbmSaasConsole16, IbmSaasConsole20, IbmSaasConsole24, IbmSaasConsole32, IbmSapOnPower16, IbmSapOnPower20, IbmSapOnPower24, IbmSapOnPower32, IbmSecureInfrastructureOnVpcForRegulatedIndustries16, IbmSecureInfrastructureOnVpcForRegulatedIndustries20, IbmSecureInfrastructureOnVpcForRegulatedIndustries24, IbmSecureInfrastructureOnVpcForRegulatedIndustries32, IbmTelehealth16, IbmTelehealth20, IbmTelehealth24, IbmTelehealth32, IbmTenet16, IbmTenet20, IbmTenet24, IbmTenet32, IbmToolchain16, IbmToolchain20, IbmToolchain24, IbmToolchain32, IbmTurbonomic16, IbmTurbonomic20, IbmTurbonomic24, IbmTurbonomic32, IbmVpnForVpc16, IbmVpnForVpc20, IbmVpnForVpc24, IbmVpnForVpc32, IbmVsiOnVpcForRegulatedIndustries16, IbmVsiOnVpcForRegulatedIndustries20, IbmVsiOnVpcForRegulatedIndustries24, IbmVsiOnVpcForRegulatedIndustries32, IbmWaziDeploy16, IbmWaziDeploy20, IbmWaziDeploy24, IbmWaziDeploy32 };
